import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import MenuIcon from '@mui/icons-material/Menu'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import * as XLSX from 'xlsx'
import Menu, { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import PlusBox from 'mdi-material-ui/PlusBox'
import PatientInformation from 'src/views/analyze/children/PatientInformation'
import Report from 'src/views/analyze/children/Report'
import QualityControl from 'src/views/analyze/QualityControl'
import DoneIcon from '@mui/icons-material/Done'
import {
  alpha,
  Autocomplete,
  Backdrop,
  CircularProgress,
  createFilterOptions,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Select,
  Switch,
  TextField,
  Theme,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography
} from '@mui/material'

import { Router, useRouter } from 'next/router'
import VariationTables, { strRang } from '@/views/analyze/VariationTables'
import {
  downLoad,
  editSample,
  fetchInfoBySampleId,
  ReportsVariants,
  Sample,
  createVariantReports,
  getVariantReports,
  editVariantReports,
  IVariantRohData,
  fetchRohList,
  IVariantRohList,
  Variation,
  fetchVariantDetails,
  GetArticlesDto,
  getArticles,
  TranslateDto,
  translate,
  exportAllVariantToCsv,
  getQCData,
  ISamplesQcRohData,
  getAlleleFrequencyQC,
  ISamplesFastQCData,
  ISamplesQcData,
  createSampleSamples,
  SampleLabels,
  getSampleSamples,
  deleteSampleSamples,
  VcfSource,
  User,
  getVariantsByFastTrack,
  fetchOMIM,
  VariantDetailOmimData,
  assumeRole,
  OssSignedUrlType,
  getSignedUrl,
  downLoad2,
  getSTRData,
  getGeneImprint,
  Pagination,
  GeneImprint,
  getGeneByHpoIds,
  UpdateMultipleCnvManualDto,
  updateCnvManualData,
  UpdateSingleCnvManualDto,
  VariantChrom,
  getCnvManualData,
  AdvancedTaskStatus,
  SingleCnvManualDto,
  getVariantReports2,
  getCnvChimerismMosaismData,
  exportSmallVariants,
  getBamUrl,
  getGlsVariants,
  getGlsRoh,
  getGlsHlaData,
  NfPlugins,
  createCnvEdit,
  listCnvEdits,
  deleteCnvEdit,
  createCnvRecurateJob,
  findCnvRecurateJob,
  getMosaic
} from '@/@core/services/app.service'
import { useMutation, useQuery } from 'react-query'
import { Stack } from '@mui/system'
import { Chip } from '@mui/material'
import Filter from 'mdi-material-ui/Filter'
import CloseIcon from '@mui/icons-material/Close'
import Check from 'mdi-material-ui/Check'
import { useTranslation } from 'react-i18next'
import FilterList from '@/@core/components/filter-variants/FilterList'
import {
  ArrowCollapseDown,
  ArrowExpandUp,
  Close,
  Delete,
  FileDocument,
  FilterOutline,
  FormatColorHighlight,
  FormatColorMarkerCancel,
  InformationOutline
} from 'mdi-material-ui'
import { JSONtoCSV, judgeAcmg } from '@/@core/layouts/utils'
import {
  calculateCoverage,
  formatDate,
  formatVariantInheritance,
  isJson,
  isWindow,
  unique
} from '@/@core/utils/utils'
import PositionedSnackbar from '@/@core/components/message'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import AddReport from './AddReport'
import VariantLists from './VariantList'
import { NObject } from '@/@core/components/filter-variants'
import { jsonToCSV } from 'react-papaparse'
import Index from '@/views/analyze/Index'
import { ExternalLinks } from '@/@core/services/api'
import UpBamFile from './UpBamFile'
import ExportList from './ExportList'
import ToggleButton from '@/@core/theme/overrides/toggleButton'
import {
  ArrowBack,
  ArrowDropDown,
  WarningAmber,
  WarningAmberRounded,
  Window
} from '@mui/icons-material'
import GroupHistogram from '@/views/analyze/children/quality-control-children/GroupHistogram'
import { Histogram } from '@antv/g2plot'
import CnvQcPlot from '@/views/analyze/children/quality-control-children/CnvQcPlot'
import CnvHG19QcPlot from '@/views/analyze/children/quality-control-children/CnvQcPlot'
import SelectReportRow from './SelectReportRow'
import { ClearIcon } from '@mui/x-date-pickers'
import OSS from 'ali-oss'
import CnvKitQcPlot from '@/views/analyze/children/quality-control-children/CnvKitQcPlot'
import CnvDellyQcPlot from '@/views/analyze/children/quality-control-children/CnvDellyQcPlot'
import QualityControlFq2 from '@/views/analyze/QualityControlFq2'
import FilterSelect from '@/@core/layouts/components/shared-components/FilterSelect'
import ClinicalSynopsisDetail from '@/views/analyze/VariationGene/ClinicalSynopsisDetail'
import CollapsibleTable from '@/views/analyze/Index/CollapsibleTable'
import { it } from 'node:test'
import EditAndAddTable from '@/views/analyze/Index/EditAndAddTable'
import { Table, TableColumnsType, TableProps } from 'antd'
import { ColumnTypes } from '@/@core/components/tables-antd'
import CnvGeneDisplay from '@/views/analyze/children/cnv-gene-display/CnvGeneDisplay'
import HLAChild from '@/views/analyze/children/children-tabs/HLA'
import { start } from 'nprogress'
import { a } from '@react-spring/web'
import CnvMosaicDialogContent, {
  formatDecimal,
  formatPercent
} from './CnvMosaicDialogOptimized'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

interface FilmOptionType {
  inputValue?: string
  id?: number
  name: string
}

interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'right' | 'left' | 'center'
  format?: (value: any) => string
}

export const chongqingExportCol = [
  {
    title: '样本名',
    key: 'sampleName',
    description: '用于标识特定生物样本的唯一名称。'
  },
  {
    title: '系统分析TOP10变异',
    key: 'totalInfo',
    description: '系统分析中发现的排名前10的重要变异信息汇总。'
  },
  {
    title: '染色体编号',
    key: 'Chrom',
    description: '变异所在染色体的编号，如1-22号染色体、X或Y染色体。'
  },
  {
    title: '染色体位置（起始）',
    key: 'pos',
    description: '变异在染色体上的起始位置坐标。'
  },
  {
    title: '染色体位置（终止）',
    key: 'pos',
    description:
      '变异在染色体上的终止位置坐标（对于点突变等，起始和终止位置可能相同）。'
  },
  {
    title: '基因',
    key: 'gene',
    description: '变异所在的基因名称，用于标识特定基因。'
  },
  {
    title: '转录本参考序列（NM编号）',
    key: 'transcript',
    description: '变异所在转录本的RefSeq编号（NM_开头），用于精确定位转录本。'
  },
  {
    title: '等位基因杂合性（Het/Homo/Hemi）',
    key: 'Zygosity',
    description:
      '等位基因的杂合状态，包括杂合（Het）、纯合（Homo）或半合子（Hemi）。'
  },
  {
    title: '氨基酸变异',
    key: 'c_nomen',
    description: '氨基酸水平的变异描述，采用HGVS命名规范（如p.Ala2Thr）。'
  },
  {
    title: '核苷酸变异',
    key: 'p_nomen',
    description: '核苷酸水平的变异描述，采用HGVS命名规范（如c.6G>A）。'
  },
  {
    title: '外显子或内含子序号',
    key: 'var_location+exon',
    description:
      '变异所在的外显子或内含子编号，用于定位变异在基因结构中的位置。'
  },
  {
    title: '遗传模式（显性/隐性/de novo）',
    key: 'inheritance',
    description: '变异的遗传模式，包括显性遗传、隐性遗传或新发突变（de novo）。'
  }
]

export const glsExportCol = [
  {
    title: 'chrom',
    key: 'chrom',
    value: '染色体编号'
  },
  {
    title: 'pos',
    key: 'pos',
    value: '变异在染色体上的位置(bp)'
  },
  {
    title: 'REF',
    key: 'REF',
    value: '参考基因组上的碱基'
  },
  {
    title: 'ALT',
    key: 'ALT',
    value: '变异后的碱基'
  },
  {
    title: 'read_depth',
    key: 'read_depth',
    value: '测序深度(覆盖该位点的总读数)'
  },
  {
    title: 'coverage',
    key: 'coverage',
    value: '覆盖度(覆盖该位点的读数比例)'
  },
  {
    title: 'allele_frequency',
    key: 'allele_frequency',
    value: '等位基因频率(变异等位基因在样本中的比例)'
  },
  {
    title: 'gene',
    key: 'gene',
    value: '变异所在的基因名称'
  },
  {
    title: 'rs_id',
    key: 'rs_id',
    value: 'dbSNP数据库中的变异ID'
  },
  {
    title: 'transcript',
    key: 'transcript',
    value: '变异所在的转录本'
  },
  {
    title: 'nuc_change',
    key: 'nuc_change',
    value: '核苷酸变化描述(如c.123A>G)'
  },
  {
    title: 'c_nomen',
    key: 'c_nomen',
    value: 'cDNA命名(HGVS命名法)'
  },
  {
    title: 'p_nomen',
    key: 'p_nomen',
    value: '蛋白质命名(HGVS命名法)'
  },
  {
    title: 'CLINVAR_variant_id',
    key: 'CLINVAR_variant_id',
    value: 'ClinVar数据库中的变异ID'
  },
  {
    title: 'CLINVAR_clnsig',
    key: 'CLINVAR_clnsig',
    value: 'ClinVar临床意义分类'
  },
  {
    title: 'CLINVAR_clnsigconf',
    key: 'CLINVAR_clnsigconf',
    value: 'ClinVar临床意义置信度'
  },
  {
    title: 'CLINVAR_clnsig_final',
    key: 'CLINVAR_clnsig_final',
    value: 'ClinVar最终临床意义分类'
  },
  {
    title: 'CLINVAR_gold_stars',
    key: 'CLINVAR_gold_stars',
    value: 'ClinVar证据等级(金星级数)'
  },
  {
    title: 'coding_effect',
    key: 'coding_effect',
    value: '编码效应(如错义、无义等)'
  },
  {
    title: 'var_location',
    key: 'var_location',
    value: '变异位置(外显子、内含子等)'
  },
  {
    title: 'transcript_ids',
    key: 'transcript_ids',
    value: '相关转录本ID列表'
  },
  {
    title: 'consequence',
    key: 'consequence',
    value: '变异后果(使用VEP或SnpEff注释)'
  },
  {
    title: 'exon',
    key: 'exon',
    value: '变异所在的外显子编号'
  },
  {
    title: 'intron',
    key: 'intron',
    value: '变异所在的内含子位置'
  },
  {
    title: 'somatic',
    key: 'somatic',
    value: '是否为体细胞变异(0/1)'
  },
  {
    title: 'pheno',
    key: 'pheno',
    value: '相关表型描述'
  },
  {
    title: 'pubmed',
    key: 'pubmed',
    value: '相关PubMed文献ID列表'
  },
  {
    title: 'inheritance',
    key: 'inheritance',
    value: '遗传模式(AD/AR/XL等)'
  },
  {
    title: 'index',
    key: 'index',
    value: '样本索引编号'
  },
  {
    title: 'InterVar',
    key: 'InterVar',
    value: 'InterVar自动注释结果'
  },
  {
    title: 'ACMG_classification',
    key: 'ACMG_classification',
    value: 'ACMG致病性分类'
  },
  {
    title: 'ACMG_priority',
    key: 'ACMG_priority',
    value: 'ACMG分类优先级'
  },
  {
    title: 'AutoGVP_classification',
    key: 'AutoGVP_classification',
    value: 'AutoGVP自动分类结果'
  },
  {
    title: 'AutoGVP_priority',
    key: 'AutoGVP_priority',
    value: 'AutoGVP分类优先级'
  },
  {
    title: 'g_score',
    key: 'g_score',
    value: '基因重要性评分'
  },
  {
    title: 'f_score',
    key: 'f_score',
    value: '功能影响评分'
  },
  {
    title: 'mastermind_MMID3',
    key: 'mastermind_MMID3',
    value: 'Mastermind变异ID'
  },
  {
    title: 'mastermind_MMCNT3',
    key: 'mastermind_MMCNT3',
    value: 'Mastermind文献计数'
  },
  {
    title: 'mastermind_gene',
    key: 'mastermind_gene',
    value: 'Mastermind基因相关文献'
  },
  {
    title: 'impact',
    key: 'impact',
    value: '变异影响程度(HIGH/MOD/LOW)'
  },
  {
    title: 'strand',
    key: 'strand',
    value: 'DNA链方向(+/-)'
  },
  {
    title: 'variant_class',
    key: 'variant_class',
    value: '变异类型(SNV/INDEL/CNV等)'
  },
  {
    title: 'QUAL',
    key: 'QUAL',
    value: 'VCF文件中变异质量值'
  },
  {
    title: 'FILTER',
    key: 'FILTER',
    value: 'VCF文件中变异过滤状态'
  },
  {
    title: 'curation',
    key: 'curation',
    value: '人工注释/审核状态'
  },
  {
    title: 'HGMD',
    key: 'HGMD',
    value: '人类基因突变数据库(HGMD)分类'
  },
  {
    title: 'gnomAD_exome_ALL',
    key: 'gnomAD_exome_ALL',
    value: 'gnomAD外显子组所有群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_AFR',
    key: 'gnomAD_exome_AFR',
    value: 'gnomAD外显子组非洲群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_AMR',
    key: 'gnomAD_exome_AMR',
    value: 'gnomAD外显子组美洲群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_ASJ',
    key: 'gnomAD_exome_ASJ',
    value: 'gnomAD外显子组阿什肯纳兹犹太群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_EAS',
    key: 'gnomAD_exome_EAS',
    value: 'gnomAD外显子组东亚群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_FIN',
    key: 'gnomAD_exome_FIN',
    value: 'gnomAD外显子组芬兰群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_NFE',
    key: 'gnomAD_exome_NFE',
    value: 'gnomAD外显子组非芬兰欧洲群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_OTH',
    key: 'gnomAD_exome_OTH',
    value: 'gnomAD外显子组其他群体等位基因频率'
  },
  {
    title: 'gnomAD_exome_SAS',
    key: 'gnomAD_exome_SAS',
    value: 'gnomAD外显子组南亚群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_ALL',
    key: 'gnomAD_genome_ALL',
    value: 'gnomAD基因组所有群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_AFR',
    key: 'gnomAD_genome_AFR',
    value: 'gnomAD基因组非洲群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_AMR',
    key: 'gnomAD_genome_AMR',
    value: 'gnomAD基因组美洲群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_ASJ',
    key: 'gnomAD_genome_ASJ',
    value: 'gnomAD基因组阿什肯纳兹犹太群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_EAS',
    key: 'gnomAD_genome_EAS',
    value: 'gnomAD基因组东亚群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_FIN',
    key: 'gnomAD_genome_FIN',
    value: 'gnomAD基因组芬兰群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_NFE',
    key: 'gnomAD_genome_NFE',
    value: 'gnomAD基因组非芬兰欧洲群体等位基因频率'
  },
  {
    title: 'gnomAD_genome_OTH',
    key: 'gnomAD_genome_OTH',
    value: 'gnomAD基因组其他群体等位基因频率'
  },
  {
    title: 'gnomADe_ALL',
    key: 'gnomADe_ALL',
    value: 'gnomAD外显子组所有群体等位基因数'
  },
  {
    title: 'gnomADe_AFR',
    key: 'gnomADe_AFR',
    value: 'gnomAD外显子组非洲群体等位基因数'
  },
  {
    title: 'gnomADe_AMR',
    key: 'gnomADe_AMR',
    value: 'gnomAD外显子组美洲群体等位基因数'
  },
  {
    title: 'gnomADe_ASJ',
    key: 'gnomADe_ASJ',
    value: 'gnomAD外显子组阿什肯纳兹犹太群体等位基因数'
  },
  {
    title: 'gnomADe_EAS',
    key: 'gnomADe_EAS',
    value: 'gnomAD外显子组东亚群体等位基因数'
  },
  {
    title: 'gnomADe_FIN',
    key: 'gnomADe_FIN',
    value: 'gnomAD外显子组芬兰群体等位基因数'
  },
  {
    title: 'gnomADe_NFE',
    key: 'gnomADe_NFE',
    value: 'gnomAD外显子组非芬兰欧洲群体等位基因数'
  },
  {
    title: 'gnomADe_OTH',
    key: 'gnomADe_OTH',
    value: 'gnomAD外显子组其他群体等位基因数'
  },
  {
    title: 'gnomADe_SAS',
    key: 'gnomADe_SAS',
    value: 'gnomAD外显子组南亚群体等位基因数'
  },
  {
    title: 'gnomAD_het_EAS',
    key: 'gnomAD_het_EAS',
    value: 'gnomAD东亚群体杂合子数'
  },
  {
    title: 'gnomAD_hom_EAS',
    key: 'gnomAD_hom_EAS',
    value: 'gnomAD东亚群体纯合子数'
  },
  {
    title: 'AF_1000g',
    key: 'AF_1000g',
    value: '千人基因组计划所有群体等位基因频率'
  },
  {
    title: 'EAS_AF_1000g',
    key: 'EAS_AF_1000g',
    value: '千人基因组计划东亚群体等位基因频率'
  },
  {
    title: 'AMR_AF_1000g',
    key: 'AMR_AF_1000g',
    value: '千人基因组计划美洲群体等位基因频率'
  },
  {
    title: 'AFR_AF_1000g',
    key: 'AFR_AF_1000g',
    value: '千人基因组计划非洲群体等位基因频率'
  },
  {
    title: 'EUR_AF_1000g',
    key: 'EUR_AF_1000g',
    value: '千人基因组计划欧洲群体等位基因频率'
  },
  {
    title: 'SAS_AF_1000g',
    key: 'SAS_AF_1000g',
    value: '千人基因组计划南亚群体等位基因频率'
  },
  {
    title: 'AA_AF',
    key: 'AA_AF',
    value: '非洲裔美国人等位基因频率'
  },
  {
    title: 'EA_AF',
    key: 'EA_AF',
    value: '欧裔美国人等位基因频率'
  },
  {
    title: 'MAX_AF',
    key: 'MAX_AF',
    value: '所有群体中最大等位基因频率'
  },
  {
    title: 'MAX_AF_POPS',
    key: 'MAX_AF_POPS',
    value: '达到最大等位基因频率的群体'
  },
  {
    title: 'AF_hom',
    key: 'AF_hom',
    value: '纯合子等位基因频率'
  },
  {
    title: 'AF_het',
    key: 'AF_het',
    value: '杂合子等位基因频率'
  },
  {
    title: 'pop_AF_hom',
    key: 'pop_AF_hom',
    value: '特定群体纯合子频率'
  },
  {
    title: 'pop_AF_het',
    key: 'pop_AF_het',
    value: '特定群体杂合子频率'
  },
  {
    title: 'SIFT_score',
    key: 'SIFT_score',
    value: 'SIFT预测得分(0-1)'
  },
  {
    title: 'polyphen2_HDIV_score',
    key: 'polyphen2_HDIV_score',
    value: 'PolyPhen-2人类多样性模型得分'
  },
  {
    title: 'motif_name',
    key: 'motif_name',
    value: '转录因子结合基序名称'
  },
  {
    title: 'motif_pos',
    key: 'motif_pos',
    value: '变异在基序中的位置'
  },
  {
    title: 'high_inf_pos',
    key: 'high_inf_pos',
    value: '是否为高信息位点(0/1)'
  },
  {
    title: 'motif_score_change',
    key: 'motif_score_change',
    value: '基序结合分数变化'
  },
  {
    title: 'CADD_phred',
    key: 'CADD_phred',
    value: 'CADD综合评分(Phred尺度)'
  },
  {
    title: 'CADD_raw',
    key: 'CADD_raw',
    value: 'CADD原始得分'
  },
  {
    title: 'canonical',
    key: 'canonical',
    value: '是否为规范转录本(0/1)'
  },
  {
    title: 'CLINSIG_priority',
    key: 'CLINSIG_priority',
    value: '临床意义优先级'
  },
  {
    title: 'CLINSIG_final',
    key: 'CLINSIG_final',
    value: '最终临床意义分类'
  },
  {
    title: 'has_clinical_synopsis',
    key: 'has_clinical_synopsis',
    value: '是否有临床摘要(0/1)'
  },
  {
    title: 'loss_of_function',
    key: 'loss_of_function',
    value: '是否为功能丧失变异(0/1)'
  },
  {
    title: 'CDS_position',
    key: 'CDS_position',
    value: '变异在CDS中的位置'
  },
  {
    title: 'withdrawn_gene',
    key: 'withdrawn_gene',
    value: '是否为撤回基因(0/1)'
  },
  {
    title: 'SIFT',
    key: 'SIFT',
    value: 'SIFT预测结果(D/T)'
  },
  {
    title: 'polyphen2',
    key: 'polyphen2',
    value: 'PolyPhen-2预测结果(B/P/D)'
  },
  {
    title: 'SpliceAI_pred_DP_AG',
    key: 'SpliceAI_pred_DP_AG',
    value: 'SpliceAI供体位点AG剪接预测得分'
  },
  {
    title: 'SpliceAI_pred_DP_AL',
    key: 'SpliceAI_pred_DP_AL',
    value: 'SpliceAI供体位点AL剪接预测得分'
  },
  {
    title: 'SpliceAI_pred_DP_DG',
    key: 'SpliceAI_pred_DP_DG',
    value: 'SpliceAI受体位点DG剪接预测得分'
  },
  {
    title: 'SpliceAI_pred_DP_DL',
    key: 'SpliceAI_pred_DP_DL',
    value: 'SpliceAI受体位点DL剪接预测得分'
  },
  {
    title: 'SpliceAI_pred_DS_AG',
    key: 'SpliceAI_pred_DS_AG',
    value: 'SpliceAI供体位点AG剪接增量得分'
  },
  {
    title: 'SpliceAI_pred_DS_AL',
    key: 'SpliceAI_pred_DS_AL',
    value: 'SpliceAI供体位点AL剪接增量得分'
  },
  {
    title: 'SpliceAI_pred_DS_DG',
    key: 'SpliceAI_pred_DS_DG',
    value: 'SpliceAI受体位点DG剪接增量得分'
  },
  {
    title: 'SpliceAI_pred_DS_DL',
    key: 'SpliceAI_pred_DS_DL',
    value: 'SpliceAI受体位点DL剪接增量得分'
  },
  {
    title: 'SpliceAI_pred_SYMBOL',
    key: 'SpliceAI_pred_SYMBOL',
    value: 'SpliceAI预测涉及的基因符号'
  },
  {
    title: 'SpliceAI_max_score',
    key: 'SpliceAI_max_score',
    value: 'SpliceAI最大预测得分'
  },
  {
    title: 'MANE_tr',
    key: 'MANE_tr',
    value: 'MANE精选转录本标识'
  },
  {
    title: 'REVEL_score',
    key: 'REVEL_score',
    value: 'REVEL综合致病性评分(0-1)'
  },
  {
    title: 'AM_class',
    key: 'AM_class',
    value: 'AlphaMissense预测分类'
  },
  {
    title: 'AM_pathogenicity',
    key: 'AM_pathogenicity',
    value: 'AlphaMissense致病性评分'
  },
  {
    title: '_id',
    key: '_id',
    value: '文档唯一标识符'
  }
]

export const glsV1ExportCol = [
  {
    title: 'ACMG分类',
    key: 'acmg_classification'
  },
  {
    title: 'ACMG证据',
    key: 'acmg_evidences'
  },
  {
    title: 'ACMG致病性优先级',
    key: 'acmg_pathogenicity_priority'
  },
  {
    title: 'ACMG评分',
    key: 'acmg_score'
  },
  {
    title: '等位基因深度',
    key: 'ad'
  },
  {
    title: '等位基因频率',
    key: 'af'
  },
  {
    title: '非洲人群频率',
    key: 'afr_af'
  },
  {
    title: '等位基因平衡',
    key: 'allele_balance'
  },
  {
    title: '变异碱基',
    key: 'alt'
  },
  {
    title: 'AM分类',
    key: 'am_class'
  },
  {
    title: 'AM致病性评分',
    key: 'am_pathogenicity'
  },
  {
    title: '美洲人群频率',
    key: 'amr_af'
  },
  {
    title: 'CADD原始分',
    key: 'cadd_raw'
  },
  {
    title: '染色体',
    key: 'chrom'
  },
  {
    title: 'ClinVar ID',
    key: 'clinvar_id'
  },
  {
    title: '变异后果',
    key: 'consequence'
  },
  {
    title: '变异后果标签',
    key: 'consequence_labels'
  },
  {
    title: '测序深度',
    key: 'dp'
  },
  {
    title: '东亚人群频率',
    key: 'eas_af'
  },
  {
    title: '欧洲人群频率',
    key: 'eur_af'
  },
  {
    title: '外显子位置',
    key: 'exon'
  },
  {
    title: '功能评分',
    key: 'f_score'
  },
  {
    title: '转录本',
    key: 'feature'
  },
  {
    title: '基因',
    key: 'gene'
  },
  {
    title: '基因ID',
    key: 'gene_id'
  },
  {
    title: 'GLS分类',
    key: 'gls_classification'
  },
  {
    title: 'GLS致病性优先级',
    key: 'gls_pathogenicity_priority'
  },
  {
    title: 'gnomAD总频率',
    key: 'gnomade_af'
  },
  {
    title: 'gnomAD非洲频率',
    key: 'gnomade_afr_af'
  },
  {
    title: 'HGVS编码',
    key: 'hgvsc'
  },
  {
    title: 'HGVS蛋白',
    key: 'hgvsp'
  },
  {
    title: '遗传模式',
    key: 'inheritances'
  },
  {
    title: '最大人群频率',
    key: 'max_af'
  },
  {
    title: '最大频率人群',
    key: 'max_af_pops'
  },
  {
    title: 'OMIM表型',
    key: 'OMIMCN'
  },
  {
    title: 'PolyPhen预测',
    key: 'polyphen'
  },
  {
    title: '参考碱基',
    key: 'ref'
  },
  {
    title: 'REVEL评分',
    key: 'revel'
  },
  {
    title: 'rsID',
    key: 'rsid'
  },
  {
    title: '南亚人群频率',
    key: 'sas_af'
  },
  {
    title: 'SIFT预测',
    key: 'sift'
  },
  {
    title: '变异位置',
    key: 'variant_locations'
  },
  {
    title: '合子类型',
    key: 'Zygosity'
  }
]

export const chromSizes = [
  {
    chrom: 'chr1',
    size: 249250621
  },
  {
    chrom: 'chr2',
    size: 243199373
  },
  {
    chrom: 'chr3',
    size: 198022430
  },
  {
    chrom: 'chr4',
    size: 191154276
  },
  {
    chrom: 'chr5',
    size: 180915260
  },
  {
    chrom: 'chr6',
    size: 171115067
  },
  {
    chrom: 'chr7',
    size: 159138663
  },
  {
    chrom: 'chr8',
    size: 146364022
  },
  {
    chrom: 'chr9',
    size: 141213431
  },
  {
    chrom: 'chr10',
    size: 135534747
  },
  {
    chrom: 'chr11',
    size: 135006516
  },
  {
    chrom: 'chr12',
    size: 133851895
  },
  {
    chrom: 'chr13',
    size: 115169878
  },
  {
    chrom: 'chr14',
    size: 107349540
  },
  {
    chrom: 'chr15',
    size: 102531392
  },
  {
    chrom: 'chr16',
    size: 90354753
  },
  {
    chrom: 'chr17',
    size: 81195210
  },
  {
    chrom: 'chr18',
    size: 78077248
  },
  {
    chrom: 'chr19',
    size: 59128983
  },
  {
    chrom: 'chr20',
    size: 63025520
  },
  {
    chrom: 'chr21',
    size: 48129895
  },
  {
    chrom: 'chr22',
    size: 51304566
  },
  {
    chrom: 'chrX',
    size: 155270560
  },
  {
    chrom: 'chrY',
    size: 59373566
  }
]

const lableData = [
  { labelName: '阴性', name: '阴性' },
  { labelName: '阳性', name: '阳性' },
  { labelName: '患者', name: '患者' },
  { labelName: '先证者', name: '先证者' },
  { labelName: '健康对照', name: '健康对照' },
  { labelName: '无症状携带', name: '无症状携带' },
  { labelName: '筛查', name: '筛查' },
  { labelName: '诊断', name: '诊断' }
]

const color = 'white'
const bgColor = 'rgb(0, 0, 0,0.6)'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 14
  }
}))

const TabSelected = styled(Tabs)(({ theme }) => ({
  '& .MuiTab-root': {
    fontFamily: 'PingFang SC',
    fontSize: '14px',
    fontWeight: '400',
    borderTopLeftRadius: '5%',
    borderTopRightRadius: '5%',
    ':hover': {
      backgroundColor: 'rgb(240,239,240)'
    }
  },
  '& .Mui-selected': {
    // backgroundColor: theme.palette.primary.main,
    color: 'theme.palette.primary.main',
    fontWeight: 'bold'
  }
}))

interface Item {
  HPO_id: string
  gene_names: string[]
}

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 150,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: '1.125rem',
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}))

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   }
// }
const filter = createFilterOptions<FilmOptionType>()

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box height="100%" sx={{ p: 3, pb: 0 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export default function SamplesTabs() {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const chipList = [
    {
      title: t('Fast track'),
      key: '0',
      checked: true
    },
    {
      title: 'SNV/INDEL',
      key: '1',
      checked: false
    },
    {
      title: 'CNV',
      key: '2',
      checked: false
    },
    {
      title: 'ROH',
      key: '3',
      checked: false
    },
    {
      title: t('MT'),
      key: '5',
      checked: false
    },
    {
      title: t('STR'),
      key: '6',
      checked: false
    },
    {
      title: 'SV',
      key: '7',
      checked: false
    },
    {
      title: t('thalassemia'),
      key: '8',
      checked: false
    },
    {
      title: `${t('thal plot')}`,
      key: '9',
      checked: false
    },
    {
      title: `${t('HLA')}`,
      key: '10',
      checked: false
    }
  ]

  const groupHistogramConf = {
    isGroup: true,
    xField: 'chrom',
    yField: 'size',
    seriesField: 'index',

    /** 设置颜色 */
    color: ['#1ca9e6', '#f88c24'],

    /** 设置间距 */
    marginRatio: 0.4,
    label: {
      // 可手动配置 label 数据标签位置
      position: 'middle', // 'top', 'middle', 'bottom'
      // 可配置附加的布局方法
      layout: [
        // 柱形图数据标签位置自动调整
        { type: 'interval-adjust-position' },

        // 数据标签防遮挡
        { type: 'interval-hide-overlap' },

        // 数据标签文颜色自动调整
        { type: 'adjust-color' }
      ]
    },
    data: []
  }

  const rohColumns: Column[] = [
    {
      id: 'chromIndex',
      label: t('#Chr'),
      align: 'left',
      format: (value) => {
        return `Chr${value}`
      }
    },
    { id: 'begin', label: t('Begin'), align: 'left' },
    {
      id: 'end',
      label: t('End'),
      align: 'left'
    },
    {
      id: 'size',
      label: `${t('Size')}(MB)`,
      align: 'left'
    },
    {
      id: 'nbVariants',
      label: t('Nb Variants'),
      align: 'left'
    },
    {
      id: 'percentageHomozygosity',
      label: `${t('Percentage Homozygosity')}(%)`,
      align: 'left'
    },
    {
      id: 'GeneImprintData',
      label: `${t('GeneImprint')}`,
      align: 'left',
      format: ((value: any[], row: any) => {
        const GeneImprintData = row.GeneImprintData

        //

        if (GeneImprintData)
          return (
            <Stack>
              {GeneImprintData.map((item: any) => {
                return (
                  <Tooltip
                    title={
                      i18n.language === 'zh'
                        ? `${item.geneName}-${item.OMIMCN ?? t('null')}`
                        : `${item.geneName}-${item.OMIMEN ?? t('null')}`
                    }
                  >
                    <Typography
                      sx={{
                        cursor:
                          item && item.clinicalSynopsis ? 'pointer' : 'inherit'
                      }}
                      onClick={() => {
                        if (item && item.clinicalSynopsis) {
                          setCurrentOMIM(item)

                          setOMIMOpen(true)
                        }
                      }}
                    >{`${item.geneName}-${item.imprintType}`}</Typography>
                  </Tooltip>
                )
              })}
            </Stack>
          )
        else return ''
      }) as any
    },
    {
      id: 'index',
      label: t('Actions'),
      align: 'left',
      format: ((value: any) => {
        return (
          <Box>
            <Button
              onClick={() => {
                handleChip1Click('1')

                setIsRoh(true)
                const temp = rohList.find((item, index) => item.index == value)

                if (temp) {
                  const newConfig = [
                    {
                      name: '染色体',
                      key: 'chrom',
                      open: false,
                      value: {
                        chrom: [
                          {
                            key: temp.chrom.substr(3),
                            title: temp.chrom
                          }
                        ],
                        posStart: temp.begin,
                        posEnd: temp.end,
                        is_ROH: ['1']
                      }
                    }
                  ]

                  if (config) {
                    const newParam = unique([...newConfig, ...config], 'key')

                    setConfig(newParam)
                  } else setConfig(newConfig)

                  handleClose()
                }
              }}
              size="small"
              variant="contained"
              sx={{
                fontSize: '0.75rem',
                padding: '6px 4px !important',
                color: 'white !important'
              }}
            >
              {t('Filter')}
            </Button>
          </Box>
        )
      }) as any
    }
  ]

  const CnvManualColumns: (ColumnTypes[number] & {
    editable?: boolean
    dataIndex: string
  })[] = [
    {
      dataIndex: 'chrom',
      key: 'chrom',
      title: t('#Chr'),
      align: 'left',
      editable: true,
      render: (value) => {
        return `Chr${value}`
      }
    },
    { dataIndex: 'start', title: t('Begin'), align: 'left', editable: true },
    {
      dataIndex: 'end',
      key: 'end',
      title: t('End'),
      align: 'left',
      editable: true
    },
    {
      dataIndex: 'type',
      key: 'type',
      title: t('Cnv Type'),
      align: 'left',
      editable: true
    },
    {
      dataIndex: 'cn',
      key: 'cn',
      title: `${t('Copy Number')}`,
      align: 'left',
      editable: true
    },
    {
      dataIndex: 'genotype',
      key: 'genotype',
      title: `${t('Genotype')}`,
      align: 'left',
      editable: true
    },
    {
      dataIndex: 'operation',
      title: `${t('actions')}`,
      align: 'center',
      render: ((data: any, row: any, index: number) => {
        if (row.items)
          return (
            <Button
              variant="contained"
              onClick={async () => {
                //
                if (analysisInfo.pipelineVersion) {
                  await deleteGlsCnvManual.mutateAsync({
                    editId: row.edit_id,
                    genome: analysisInfo.genomeBuild,
                    sampleId: id as unknown as number
                  })

                  await getGlsCnvManual.mutateAsync({
                    genome: analysisInfo.genomeBuild,
                    sampleId: id as unknown as number
                  })
                } else {
                  const param: UpdateMultipleCnvManualDto = {
                    variants: EditAndAddTableRef.current?.dataSource.filter(
                      (items: any, Index: number) => items.key !== row.key
                    ),
                    mode: 'override'
                  }

                  await updateCnvManual.mutateAsync({
                    data: param,
                    id: id as unknown as number
                  })

                  getCnvManual.mutateAsync(id as unknown as number)
                }
              }}
              sx={{
                color: 'white !important'
              }}
              size="small"
            >
              {t('delete')}
            </Button>
          )
        else {
          return (
            <Button
              variant="contained"
              onClick={async () => {
                EditAndAddTableRef.current?.handleDelete &&
                  EditAndAddTableRef.current.handleDelete(row)
              }}
              sx={{
                color: 'white !important'
              }}
              size="small"
            >
              {t('delete')}
            </Button>
          )
        }
      }) as any
    }
  ]

  const CnvChimerismMosaismColumns: TableProps<any>['columns'] = [
    {
      dataIndex: 'chrom',
      key: 'chrom',
      title: t('Position'),
      align: 'left',
      render: (value) => {
        return `ChrX`
      }
    },
    { dataIndex: 'start_position', title: t('Begin'), align: 'left' },
    {
      dataIndex: 'end_position',
      key: 'end_position',
      title: t('End'),
      align: 'left'
    },
    {
      dataIndex: 'region_span_mb',
      key: 'region_span_mb',
      title: t('Region Span (MB)'),
      align: 'left',
      render: (value) => {
        return value.toFixed ? value.toFixed(3) : Number(value).toFixed(3)
      }
    },
    {
      dataIndex: 'mean_ratio',
      key: 'mean_ratio',
      title: `${t('Avg Ratio')}`,
      align: 'left',
      render: (value) => {
        return value.toFixed ? value.toFixed(3) : Number(value).toFixed(3)
      }
    },
    {
      dataIndex: 'min_ratio',
      key: 'min_ratio',
      title: `${t('Min Ratio')}`,
      align: 'left',
      render: (value) => {
        return value.toFixed ? value.toFixed(3) : Number(value).toFixed(3)
      }
    },
    {
      dataIndex: 'max_ratio',
      key: 'max_ratio',
      title: `${t('Max Ratio')}`,
      align: 'left',
      render: (value) => {
        return value.toFixed ? value.toFixed(3) : Number(value).toFixed(3)
      }
    }
  ]

  const MosaicColumns: TableProps<any>['columns'] = [
    {
      dataIndex: 'chrom',
      key: 'chrom',
      title: t('Position'),
      align: 'left',
      render: (value, row) => {
        return `${row.chrom}:${row.start}-${row.end}`
      }
    },
    {
      dataIndex: 'scale',
      title: t('Scale'),
      align: 'left',
      render: (value) => {
        return value
      }
    },
    {
      dataIndex: 'finding_type',
      key: 'finding_type',
      title: t('Finding'),
      align: 'left',
      render: (value) => {
        return value
      }
    },
    {
      dataIndex: 'grade',
      key: 'grade',
      title: t('Grade'),
      align: 'left',
      render: (value) => {
        return value
      }
    },
    {
      dataIndex: 'cell_fraction',
      key: 'cell_fraction',
      title: `${t('Cell Fraction')}`,
      align: 'left',
      render: (v: number) => formatPercent(v)
    },
    {
      dataIndex: 'bdev',
      key: 'bdev',
      title: `${t('Alleleic Imbalance')}`,
      align: 'left',
      render: (v: number) => formatDecimal(v)
    },
    {
      dataIndex: 'n_het_sites',
      key: 'n_het_sites',
      title: `${t('Informative sites')}`,
      align: 'left',
      render: (value) => {
        return value
      }
    },
    {
      dataIndex: 'n_independent_loci',
      key: 'n_independent_loci',
      title: `${t('Independent loci')}`,
      align: 'left',
      render: (value) => {
        return value
      }
    }
  ]

  const expandCnvManualColumns: TableColumnsType<any> = [
    {
      dataIndex: 'chrom',
      key: 'chrom',
      title: t('#Chr'),
      align: 'left',
      render: (value) => {
        return `Chr${value}`
      }
    },
    { dataIndex: 'start', key: 'start', title: t('Begin'), align: 'left' },
    {
      dataIndex: 'end',
      key: 'end',
      title: t('End'),
      align: 'left'
    },
    {
      dataIndex: 'type',
      key: 'type',
      title: t('Cnv Type'),
      align: 'left'
    },
    {
      dataIndex: 'cn',
      key: 'cn',
      title: `${t('Copy Number')}`,
      align: 'left'
    },
    {
      dataIndex: 'genotype',
      key: 'genotype',
      title: `${t('Genotype')}`,
      align: 'left'
    }
  ]
  const [rohFilterValue, setRohFilterValue] = React.useState({
    size: 3,
    nbVariants: 0,
    percentageHomozygosity: 90
  })
  const [sampleLabelValue, setSampleLabelValue] = React.useState<
    FilmOptionType[]
  >([])
  const [geneList, setGeneList] = React.useState<Item[]>([])
  const [sampleLabel, setSampleLabel] = React.useState<any[]>([])
  const [value, setValue] = React.useState(0)
  const [cnvValue, setCnvValue] = React.useState(0)
  const [cnvAllValue, setCnvAllValue] = React.useState(0)
  const [config, setConfig] = React.useState<any>()
  const [variantListConfig, setVariantListConfig] = React.useState<any>({})
  const [rohList, setRohList] = React.useState<IVariantRohData[]>([])
  const [GeneImprintData, setGeneImprintData] = React.useState<GeneImprint[]>(
    []
  )
  const tableRef = React.useRef<any>()
  const filterRef = React.useRef<any>()
  const messageRef = React.useRef<any>()
  const iframeRef = React.useRef<any>(null)
  const EditAndAddTableRef = React.useRef<any>(null)
  const groupHistogramRef = React.useRef<{
    plot: {
      current: Histogram
    }
  }>()
  const [reportVariantId, setReportVariantId] = React.useState<any>()
  const [selectRowKey, setSelectRowKey] = React.useState<Array<any>>([])
  const [hlaData, setHlaData] = React.useState<Array<any>>([])

  const [CnvManual, setCnvManual] = React.useState<Array<any>>([])
  const [CnvChimerismMosaism, setCnvChimerismMosaism] = React.useState<
    Array<any>
  >([])
  const [CnvMosaic, setCnvMosaic] = React.useState<any>({})
  const [CnvChimerismMosaismPng, setCnvChimerismMosaismPng] =
    React.useState<string>('')
  const [selectReportRowKey, setSelectReportRowKey] = React.useState<
    Array<any>
  >([])
  const [chips, setChips] = React.useState(chipList)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [anchorCsvEl, setAnchorCsvEl] = React.useState<null | HTMLElement>(null)
  const [anchorGenomeBuildEl, setAnchorGenomeBuildEl] =
    React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const openCsv = Boolean(anchorCsvEl)
  const openGenomeBuild = Boolean(anchorGenomeBuildEl)
  const [CnvManualOpen, setCnvManualOpen] = React.useState(false)
  const [CnvChimerismOpen, setCnvChimerismOpen] = React.useState(false)
  const [CnvManualFormOpen, setCnvManualFormOpen] = React.useState(false)
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [OMIMOpen, setOMIMOpen] = React.useState(false)
  const [filterToggle, setFilterToggle] = React.useState(false)
  const [indexChecked, setIndexChecked] = React.useState(true)
  const [colorToggle, setColorToggle] = React.useState(true)
  const [rohOpen, setRohOpen] = React.useState(false)
  const [phenotypeOpen, setPhenotypeOpen] = React.useState(false)
  const [variantOpen, setVariantOpen] = React.useState(false)
  const [upBamOpen, setUpBamOpen] = React.useState(false)
  const [downloadReportOpen, setDownloadReportOpen] = React.useState(false)
  const [exportOpen, setExportOpen] = React.useState(false)
  const [createSampleLabelsOpen, setCreateSampleLabelsOpen] =
    React.useState(false)
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [analysisInfo, setAnalysisInfo] = React.useState<any>({})
  const [isRoh, setIsRoh] = React.useState(false)
  const [currentOMIM, setCurrentOMIM] = React.useState<any>()
  const [isFiltering, setIsFiltering] = React.useState(false)
  const [ManualValue, setManualValue] = React.useState({
    chrom: '',
    CN: 0,
    cnvType: 'DUP',
    phenotype: '',
    start: '',
    end: '',
    chr: '',
    note: ''
  })
  const [sampleList, setSampleList] = React.useState<Sample[]>()
  const [GlsCnvManual, setGlsCnvManual] = React.useState<any[]>()

  const [menuList, setMenuList] = React.useState([
    {
      title: t('Key finding'),
      key: 'KeyFinding',
      value: [] as any[],
      variantReportsId: null
    },
    {
      title: t('Incidental discovery'),
      key: 'IncidentalDiscovery',
      value: [] as any[],
      variantReportsId: null
    },
    {
      title: t('Carrier screening'),
      key: 'CarrierScreening',
      value: [] as any[],
      variantReportsId: null
    },
    {
      title: t('ACMG discovery'),
      key: 'ACMGDiscovery',
      value: [] as any[],
      variantReportsId: null
    },
    {
      title: t('Other discovery'),
      key: 'OtherDiscovery',
      value: [] as any[],
      variantReportsId: null
    }
  ])

  const chipQuery = React.useMemo(() => {
    return {
      ...chips.find((item) => item.checked)
    }
  }, [chips])

  const filterQuery = React.useMemo(() => {
    let filter = {
      // chrom: '1',
      // posStart: '',
      // posEnd: '',
      // inheritance: null,
      // isUse: null,
      // phenotypes: [],
      // readDepthOperator: '',
      // readDepthValue: '',
      // indelOperator: '',
      // indelValue: '',
      // snvOperator: '',
      // snvValue: '',
      // qualMin: 0,
      // qualMax: 0,
      // zygosity: '',
      // gnomAD: [],
      // gnomADOperator: '',
      // gnomADValue: '',
      // classification: null,
      // insilico: [],
      // CADDValue: 15
    } as any
    let filterQuery = {} as any

    if (config) {
      Object.getOwnPropertyNames(config).map((key) => {
        const items = config[key as unknown as number] as any

        if (items.key) {
          filter = {
            ...filter,
            ...items.value
          }
        }
      })
    }

    Object.getOwnPropertyNames(filter).map((key) => {
      let items = filter[key]

      if (
        key === 'sequenceOntology' ||
        key === 'tokenToLabels' ||
        key === 'tokenToLocations'
      )
        items = filter[key].map((item: { value: any }) => item.value.id)
      else if (key === 'geneSet')
        items = filter[key].map((item: { name: any }) => item.name)
      else if (key === 'chrom')
        items = filter[key].map((item: { key: any }) => item.key)
      else if (key === 'scipGeneHiIn')
        items = filter[key].map((item: { key: any }) => item.key)
      else if (key === 'scipGeneTsIn')
        items = filter[key].map((item: { key: any }) => item.key)
      else if (key === 'scipClingenHaploIn')
        items = filter[key].map((item: { key: any }) => item.key)
      else if (key === 'scipClingenTriploIn')
        items = filter[key].map((item: { key: any }) => item.key)
      else if (key === 'mimNumbers')
        items = filter[key].map((item: { omim_code: any }) => item.omim_code)
      else if (key === 'phenotypes')
        items = filter[key].map((item: { name_en: any; pre_title: any }) =>
          item.name_en ? item.name_en : item.pre_title
        )
      else if (key === 'userLocusIn')
        items = filter[key].map((item: { name_en: any; pre_title: any }) =>
          item.name_en ? item.name_en : item.pre_title
        )
      else if (key === 'userLocusOut')
        items = filter[key].map((item: { name_en: any; pre_title: any }) =>
          item.name_en ? item.name_en : item.pre_title
        )
      else if (key === 'gscoreValue') items = filter[key] / 100
      else if (key === 'is_ROH') items = filter[key].length ? 1 : 0
      else if (key === 'is_loss_of_function') items = filter[key].length ? 1 : 0
      else if (key === 'hasPubmed') items = filter[key].length ? 1 : 0

      if (Array.isArray(items)) {
        if (items.length)
          filterQuery = {
            ...filterQuery,
            [key]: items
          }
      } else if (items || (items === 0 && key === 'minValue')) {
        filterQuery = {
          ...filterQuery,
          [key]: items
        }
      }
    })

    return filterQuery
  }, [config])

  const router = useRouter()

  const { id } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analysis'

  const handleCsvMenuClick = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorCsvEl(e.currentTarget)

  const handleCsvClose = () => {
    setAnchorCsvEl(null)
  }

  const toggleDrawer = () => setDrawerOpen(!drawerOpen)
  const mouseLeaveDrawer = () => setDrawerOpen(false)

  const handleIframeLoad = () => {
    if (iframeRef.current) {
      try {
        const iframeDoc =
          iframeRef.current.contentDocument ||
          iframeRef.current.contentWindow.document

        // 操作iframe的DOM

        console.log(
          'iframeDoc',
          iframeDoc.getElementById('ratio-value')?.innerHTML
        )
      } catch (e) {
        console.error('无法访问iframe内容:', e)
      }
    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const body = document.body

    if (newValue === 2) {
      body.style.overflow = 'hidden !important'

      body.setAttribute('style', 'overflow: hidden !important; ')
    } else {
      body.style.overflow = 'inherit !important'

      body.setAttribute('style', 'overflow: inherit !important; ')
    }

    setValue(newValue)

    setSelectRowKey([])

    setDrawerOpen(false)

    if (newValue !== 1) {
      // 使用querySelectorAll获取所有类名为tooltip的元素
      const tooltips = document.querySelectorAll('.tooltip')

      // 遍历这些元素并逐个从DOM中移除
      tooltips.forEach(function (tooltip) {
        tooltip.remove()
      })
    } else {
      setTimeout(() => {
        const rohPlotData = rohList.map((items, index) => {
          // const chroms = rohList
          //   .filter((item) => item.chrom === items.chrom)
          //   .map((item) => Number(item.size) * 1000000)

          const Size = Number(items.size)

          // const chromSize = chroms.reduce(
          //   (accumulator, currentValue) => accumulator + Number(currentValue),
          //   0
          // )

          const temp = chromSizes.find((item) => item.chrom === items.chrom)
          let isUPD = false

          if (temp) {
            isUPD = Size / (temp.size / 1000000) > 0.05
          }

          return {
            ...items,
            Size,
            isUPD,
            index
          }
        })

        groupHistogramRef.current &&
          groupHistogramRef.current?.plot.current.changeData(rohPlotData)
      }, 1500)
    }
    filterRef.current && filterRef.current.reset && filterRef.current.reset()

    setIsFiltering(false)
  }

  const handleAddReport = async (
    event: React.MouseEvent<HTMLElement>,
    index: number,
    item: {
      title: any
      key:
        | 'KeyFinding'
        | 'IncidentalDiscovery'
        | 'CarrierScreening'
        | 'ACMGDiscovery'
      value: any[]
      variantReportsId: number | null
    }
  ) => {
    const list = menuList.map((item) => item.value).flat()

    if (list.length && item.variantReportsId) {
      //
      const params: ReportsVariants = {
        id: item.variantReportsId,
        objectId: id as unknown as number,
        objectType: type as any,
        snvVariants: JSON.stringify([
          ...list,
          ...selectRowKey.map((items: any) => {
            delete items.transcript_list
            delete items.Index
            delete items.GeneIndex

            return {
              ...items,
              variantsType: item.key
            }
          })
        ]),
        cnvVariants: null,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      await editReportVariant.mutateAsync(params)
    } else {
      const params: ReportsVariants = {
        objectId: id as unknown as number,
        objectType: type as any,
        snvVariants: JSON.stringify(
          selectRowKey.map((items: any) => {
            delete items.transcript_list
            delete items.Index
            delete items.GeneIndex
            delete items.tempHistory
            delete items.tempGlsIndex
            delete items.LitVarArticles
            delete items.Articles

            return {
              ...items,
              variantsType: item.key
            }
          })
        ),
        cnvVariants: null,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      await addReportVariants.mutateAsync(params)
    }

    // reportsVariantsRefetch()

    if (id && type)
      getReportsVariants.mutateAsync({
        objectId: id as string,
        objectType: type
      })

    setSelectRowKey([])

    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)

    setDialogOpen(false)

    setRohOpen(false)

    setVariantOpen(false)

    setUpBamOpen(false)

    setExportOpen(false)

    setDownloadReportOpen(false)

    setCreateSampleLabelsOpen(false)

    setPhenotypeOpen(false)

    handleCsvClose()

    setSampleLabelValue([])

    setSelectReportRowKey([])

    tableRef.current &&
      tableRef.current.resetRowSelect &&
      tableRef.current.resetRowSelect()
  }

  const handleClickOpen = () => {
    setDialogOpen(true)
  } // 合并函数

  const mergeIntervalsFn = (
    array: SingleCnvManualDto[],
    newType: string,
    newCn: number,
    newGenotype: string
  ) => {
    // 按 chrom 分组  const groups = {};
    const groups: NObject = {}

    array.forEach((item) => {
      const { chrom, start, end, cn, type, genotype } = item

      if (!groups[chrom]) {
        groups[chrom] = {
          chrom,
          cn,
          type,
          genotype,
          start: Infinity,
          end: -Infinity,
          items: []
        }
      }

      // 更新 start 和 end

      groups[chrom].start = Math.min(groups[chrom].start, start)

      groups[chrom].end = Math.max(groups[chrom].end, end)

      groups[chrom].cn = newCn

      groups[chrom].type = newType

      groups[chrom].genotype = newGenotype

      groups[chrom].items.push(item)
    })

    return Object.values(groups)
  }

  const mergeIntervals = (
    array: SingleCnvManualDto[],
    newType: string,
    newCn: number,
    newGenotype: string
  ) => {
    // 按 chrom 分组  const groups = {};
    const groups: NObject = {}

    array.forEach((item) => {
      const { chrom, start, end, cn, type, genotype } = item

      if (!groups[chrom]) {
        groups[chrom] = {
          chrom,
          cn,
          type,
          genotype,
          start: Infinity,
          end: -Infinity,
          items: []
        }
      }

      // 更新 start 和 end

      groups[chrom].start = Math.min(groups[chrom].start, start)

      groups[chrom].end = Math.max(groups[chrom].end, end)

      groups[chrom].cn = newCn

      groups[chrom].type = newType

      groups[chrom].genotype = newGenotype

      groups[chrom].items.push(item)

      setManualValue({
        ...ManualValue,
        chr: chrom,
        chrom: `${chrom}:${groups[chrom].start}-${groups[chrom].end}`,
        start: groups[chrom].start,
        end: groups[chrom].end
      })
    })

    return Object.values(groups)
  }

  const createCnvManual = () => {
    const variants = mergeIntervals(
      selectRowKey.map((items: any) => {
        return {
          chrom: `${items.chrom}` as VariantChrom,
          start: Number(items.SV_start ?? items.start),
          end: Number(items.SV_end ?? items.end),
          type: items.SV_type ?? items.sv_type,
          cn: Number(items.CN ?? items.cn),
          genotype: '0/1'
        }
      }),
      ManualValue.cnvType,
      ManualValue.CN,
      ManualValue.phenotype ? '1/1' : '0/1'
    )

    //

    setCnvManual(variants)

    return variants
  }

  const handleCnvManual = async () => {
    if (analysisInfo.pipelineVersion) {
      getGlsCnvManual.mutateAsync({
        genome: analysisInfo.genomeBuild,
        sampleId: id as unknown as number
      })
    } else getCnvManual.mutateAsync(id as unknown as number)

    // fetchCnvChimerismMosaismData.mutateAsync(id as unknown as number)

    setCnvManualOpen(true)
  }

  const handleCnvChimerism = async () => {
    if (analysisInfo.pipelineVersion)
      fetchGlsCnvChimerismMosaismData.mutateAsync(id as unknown as string)
    else fetchCnvChimerismMosaismData.mutateAsync(id as unknown as number)

    setCnvChimerismOpen(true)
  }

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleChip1Click = (index: string) => {
    setIsRoh(false)

    //

    setChips(
      chips.map((items) => {
        items.checked = false

        if (items.key === index) {
          items.checked = true
        }

        return items
      })
    )

    filterRef.current && filterRef.current.reset && filterRef.current.reset()

    setIsFiltering(false)
  }

  const getCsvData = async (item: any) => {
    // const detail = (await getVariantDetail.mutateAsync(item)) as any
    const detail = {} as any

    const params = {
      gene: item.gene,
      rsId: item.rs_id,
      pnomen: item.p_nomen,
      cnomen: item.c_nomen,
      pubmed: `${item.pubmed}`,
      omimPubmed: item.OMIM?.pubmedIds,
      searchScholar: false
    }

    if (item.MitoMap) {
      params.omimPubmed = item.MitoMap.pubmed_ids
    }

    item.detail = detail

    // if (params.omimPubmed) {
    //   const articles = await Articles.mutateAsync(params)

    //   //

    //   const variantPubmedArticles = articles?.variantPubmedArticles
    //   const genePubmedArticles = articles?.genePubmedArticles
    //   const totalArticles = variantPubmedArticles?.concat(genePubmedArticles)

    //   item.articles = articles ? articles?.articles : ''

    //   item.variantArticles_en = variantPubmedArticles
    //     ? variantPubmedArticles
    //         ?.map((item: any) => {
    //           return `${item.authors.join(',')}--${item.title}--${item.url}`
    //         })
    //         .join('--;')
    //     : ''

    //   item.geneArticles_en = genePubmedArticles
    //     ? genePubmedArticles
    //         ?.map((item: any) => {
    //           return `${item.authors.join(',')}--${item.title}--${item.url}`
    //         })
    //         .join('--;')
    //     : ''

    //   item.articles_en = totalArticles
    //     ? totalArticles
    //         ?.map((item: any) => {
    //           return `${item.authors.join(',')}--${item.title}--${item.url}`
    //         })
    //         .join('--;')
    //     : ''
    // }

    //

    item.sampleName = analysisInfo.name

    item.Chrom = `chr${item.chrom}`

    item['var_location+exon'] = `${item.var_location}:${item.exon}`

    item.sampleName = analysisInfo.name

    item.sampleName = analysisInfo.name

    item.totalInfo = `${item.transcript}(${item.gene}):${item.c_nomen}(${item.p_nomen})`

    item.mis_z = detail.genePli?.mis_z

    item.syn_z = detail.genePli?.syn_z

    item.pLI = detail.genePli?.pLI

    item.pLI = detail.genePli?.pLI

    item.clinicalSynopsis_en = JSON.stringify(detail.clinicalSynopsis)

    // const clinicalSynopsisParams: TranslateDto = {
    //   sourceLanguage,
    //   targetLanguage,
    //   sourceText: JSON.stringify(detail.clinicalSynopsis)
    // }

    // item.clinicalSynopsis_zh = await Translate.mutateAsync(
    //   clinicalSynopsisParams
    // )

    item.clinvarGraph = JSON.stringify(detail.clinvarGraph)

    item.functionZh = detail.geneInfo?.functionZh

    item.conditionZh = JSON.stringify(detail.geneInfo?.conditionZh)

    const hgmd: any[] = detail.hgmd ?? []

    const CLASS = hgmd.find((item) => item.name === 'CLASS')
    const PHEN = hgmd.find((item) => item.name === 'PHEN')

    if (CLASS && PHEN) item.CLASS_PHEN = `${CLASS.value}_${PHEN.value}`

    item.chrom_pos = `${item.chrom}:${item.pos}`

    item.exon = `\t${item.exon}`

    item.coverage = `\t${item.coverage}`

    const OMIMData1 = item.OMIM?.omimData
      ? item.OMIM?.omimData
      : item.omim_phenotypes
      ? item.omim_phenotypes
      : item.omim_genes
      ? item.omim_genes.map((item: any) => item.omim_phenotypes).flat()
      : item.oldOMIMData
      ? item.oldOMIMData
      : []
    const oldOMIMData = OMIMData1.map((item: any) => {
      const inheritances: string[] = []
      const clinicalSynopsiss = isJson(item.clinical_synopsis)
        ? JSON.parse(item.clinical_synopsis)
        : item.clinicalSynopsis

      if (
        item &&
        clinicalSynopsiss &&
        clinicalSynopsiss.INHERITANCE &&
        Array.isArray(clinicalSynopsiss.INHERITANCE)
      ) {
        clinicalSynopsiss.INHERITANCE.forEach((str: string) =>
          inheritances.push(str.toLowerCase())
        )
        const inheritance = formatVariantInheritance(
          Array.from([...new Set(inheritances)]).join(',')
        )

        item.inheritance =
          inheritance || inheritance !== ''
            ? inheritance
            : Array.from([...new Set(clinicalSynopsiss.INHERITANCE)]).join(',')
      }

      return item
    })
    const newOMIMData = item.OMIM?.geneDiseaseTranslated?.data
      ? item.OMIM?.geneDiseaseTranslated?.data
      : item.omim_curate_phenotypes
      ? item.omim_curate_phenotypes
      : item.omim_genes
      ? item.omim_genes.map((item: any) => item.omim_curate_phenotypes).flat()
      : item.newOMIMData
      ? item.newOMIMData
      : []

    item.OMIMValue = item.OMIM
      ? item.OMIM.omimData
          .map((i: { phenoName: any }) => i.phenoName)
          .join('，')
      : ''

    item.OMIMValueZn = item.OMIM
      ? item.OMIM.omimData
          .map((i: { pheno_name_cn: any }) => i.pheno_name_cn)
          .join('，')
      : ''

    item.OMIMCN = `${unique(newOMIMData, 'disease')
      .map((item: any) => {
        return `${item.genetic_mode}-${item.disease}`
      })
      .filter((item) => item)
      .join(',')}`

    item.OMIMEN = `${unique(oldOMIMData, 'phenoName')
      .map((item: any) => {
        return `${item.inheritance}-${item.phenoName ?? item.pheno_name}`
      })
      .filter((item) => item)
      .join(',')}`

    // if (item.OMIMValue) {
    //   const OMIMparams: TranslateDto = {
    //     sourceLanguage,
    //     targetLanguage,
    //     sourceText: item.OMIMValue
    //   }

    //   item.OMIMValueZn = await Translate.mutateAsync(OMIMparams).catch(
    //     (err) => ''
    //   )
    // }

    const inheritance_OMIMValue = item.OMIM?.omimData
      .map((item: any) => {
        const inheritances: string[] = []

        if (
          item &&
          item.clinicalSynopsis &&
          item.clinicalSynopsis.INHERITANCE &&
          Array.isArray(item.clinicalSynopsis.INHERITANCE)
        ) {
          item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
            inheritances.push(str.toLowerCase())
          )
        }
        const inheritance = formatVariantInheritance(
          Array.from([...new Set(inheritances)]).join(',')
        )

        return {
          ...item,
          inheritance
        }
      })
      .map(
        (items: any) =>
          `(${items.inheritance ? items.inheritance : '.'})-${
            items.phenoName
          }-${items.pheno_name_cn}`
      )
      .join(';')

    item.inheritance_OMIMValue = inheritance_OMIMValue

    item.Details = `${item.gene}为${
      item.allele_frequency < 0.85 ? '杂合' : '纯合'
    }， ${judgeAcmg(item.ACMG_classification)}。${item.c_nomen} (  ${
      item.p_nomen
    } )，该变异在Gnomad中的最高人群频率是${
      item.gnomAD_exome_ALL
    }。 根据证据，这个错义变异在临床意义上被分类为${judgeAcmg(
      item.ACMG_classification
    )}。`

    item.OMIMID = item.OMIM
      ? item.OMIM.omimData.map((i: { omimData: any }) => i.omimData).join('，')
      : ''

    item.Zygosity = item.allele_frequency < 0.85 ? '杂合' : '纯合'

    return {
      ...item,
      ...analysisInfo
    }
  }

  // ========== 辅助函数 ==========
  // 污染判定逻辑
  const getContaminationInfo = (score: number | undefined) => {
    if (score === undefined || score < 0.01)
      return { color: undefined, label: t('No DNA contamination') }
    if (score > 0.03)
      return { color: 'error' as const, label: t('DNA contamination') }
    if (score > 0.01 && score < 0.03)
      return {
        color: 'warning' as const,
        label: t('Possible DNA contamination')
      }
    return { color: undefined, label: '' }
  }

  // 性别警告逻辑
  const getGenderWarning = (info: any) => {
    const isVcf = info.sampleType === 'vcf'
    const mismatch =
      (isVcf && info.gender !== info.patientGender) ||
      (!isVcf && info.gender !== info.genderPredictV2) ||
      info.patientGender === 'unknown' ||
      info.genderPredictV2 === 'unknown'
    const predictedGender = isVcf ? info.gender : info.genderPredictV2
    return {
      mismatch,
      predictedGender: t(predictedGender)
    }
  }

  // 可复用的 Chip 样式
  const chipBaseSx = {
    borderRadius: '4px',
    maxWidth: 300
  }

  // 可复用的 Tooltip + Chip 组件
  const InfoChip = ({
    label,
    color,
    tooltip,
    onClick,
    icon,
    sx = {},
    keys
  }: {
    label: string
    color?:
      | 'default'
      | 'primary'
      | 'secondary'
      | 'error'
      | 'info'
      | 'success'
      | 'warning'
    tooltip?: string
    onClick?: () => void
    icon?: React.ReactNode
    sx?: any
    keys?: string
  }) => {
    let chip = (
      <Chip
        sx={{ ...chipBaseSx, ...(onClick ? { cursor: 'pointer' } : {}), ...sx }}
        label={label}
        color={color}
        icon={icon as any}
        onClick={onClick}
      />
    )
    console.log(keys)

    if (keys === 'genomeBuild') {
      chip = (
        <Chip
          sx={{
            ...chipBaseSx,
            ...(onClick ? { cursor: 'pointer' } : {}),
            ...sx
          }}
          label={label}
          color={color}
          deleteIcon={icon as any}
          onDelete={(e) => setAnchorGenomeBuildEl(e.currentTarget)}
        />
      )
    }
    return tooltip ? (
      <Tooltip title={tooltip} placement="top-start">
        {chip}
      </Tooltip>
    ) : (
      chip
    )
  }

  // Sample Label 点击处理（消除重复）
  const handleLabelClick = async () => {
    const labels = await fetchSampleSamples.mutateAsync({ sampleId: id })
    setCreateSampleLabelsOpen(true)
    setSampleLabelValue(
      labels.map((item: { labelName: any }) => ({
        ...item,
        name: item.labelName
      }))
    )
  }

  const delayedCsvDataRequest = async (data: any, delay = 200) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        getCsvData(data)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, delay)
    })
  }

  const handleExportCsv = async (agentName?: string, list?: any[]) => {
    let vatiants = []
    let thirtColumn: any[] = []
    if (agentName === '重庆') {
      thirtColumn = chongqingExportCol
    } else {
      if (analysisInfo.pipelineVersion) {
        thirtColumn = glsV1ExportCol
      } else {
        thirtColumn = glsExportCol
      }
    }
    const data = []
    const groupSize = 2

    if (list && list.length) {
      vatiants = list
    } else {
      vatiants = selectRowKey
    }

    for (let i = 0; i < vatiants.length; i += groupSize) {
      const group = vatiants.slice(i, i + groupSize)

      const groupResults = await Promise.all(group.map(getCsvData))

      data.push(...groupResults)
    }

    console.log('data', data, vatiants, list)

    const arr = data.map((item) => {
      const obj: NObject = {}

      thirtColumn.map((i) => {
        obj[i.title] = item[i.key]
      })

      return obj
    })

    messageRef?.current?.handleClick(t('Export success'), 'success')

    // 导出XLSX
    const worksheet1 = XLSX.utils.json_to_sheet(arr)
    const worksheet2 = XLSX.utils.json_to_sheet(thirtColumn)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet1, 'Sheet1')
    XLSX.utils.book_append_sheet(workbook, worksheet2, 'read me')

    XLSX.writeFile(
      workbook,
      `${analysisInfo.name}-${formatDate(new Date())}.xlsx`
    )

    handleCsvClose()
  }

  const fetchGlsHlaData = useMutation({
    mutationFn: async (data: { id: string }) => await getGlsHlaData(data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      console.log('data', data)
      if (data && data.genes && data.genes.length) {
        setHlaData(
          data.genes.map((i: any, index: number) => {
            return {
              ...i,
              id: index + 1
            }
          })
        )
      }
    }
  })

  const updataCnvRecurateJob = useMutation({
    mutationFn: async (data: { sample_id: string }) =>
      await createCnvRecurateJob(data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data) {
        // getCnvManual.mutateAsync(params.id)
      }
    }
  })

  const updateGLsCnvManual = useMutation({
    mutationFn: async (data: {
      genome: string
      sample_id: number
      parquet_type: string
      removed: any[]
      merge_span: any
      note: string
      created_by: string
    }) => await createCnvEdit(data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data) {
        // getCnvManual.mutateAsync(params.id)
      }
    }
  })

  const getGlsCnvManual = useMutation({
    mutationFn: async (data: { genome: string; sampleId: number }) =>
      await listCnvEdits(data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data && data.edits) {
        // getCnvManual.mutateAsync(params.id)
        const edits = data.edits.map((i: any) => ({
          ...i,
          id: i.variant_id,
          chrom: i.merge_span_chrom,
          start: i.merge_span_start,
          end: i.merge_span_end,
          type: i.merge_span_sv_type,
          items: i.removed_rows.map((j: any) => ({
            ...j,
            id: j.variant_id,
            chrom: j.chrom,
            start: j.start,
            end: j.end,
            type: j.sv_type
          }))
        }))
        setCnvManual(edits)
      }
    }
  })

  const findGlsCnvManual = useMutation({
    mutationFn: async (data: { type: string; sample_id: string }) =>
      await findCnvRecurateJob(data),
    onSuccess: (
      data: {
        data: any[]
      },
      params
    ) => {
      //post返回的结果
      if (data && data.data && data.data.length) {
        setGlsCnvManual(data.data)
      }
    }
  })

  const deleteGlsCnvManual = useMutation({
    mutationFn: async (data: {
      editId: string
      sampleId: number
      genome: string
    }) => await deleteCnvEdit(data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data) {
        // getCnvManual.mutateAsync(params.id)
      }
    }
  })

  const updateCnvManual = useMutation({
    mutationFn: async (data: {
      data: UpdateMultipleCnvManualDto
      id: number
    }) => await updateCnvManualData(data.id, data.data),
    onSuccess: (data: any, params) => {
      //post返回的结果
      if (data) {
        // getCnvManual.mutateAsync(params.id)
      }
    }
  })

  const getCnvManual = useMutation({
    mutationFn: async (id: number) => await getCnvManualData(id),
    onSuccess: (data: any[]) => {
      //post返回的结果
      // setOMIM(datas)

      setCnvManual(data)
    }
  })

  const fetchGlsCnvChimerismMosaismData = useMutation({
    mutationFn: async (id: string) => await getMosaic({ id }),
    onSuccess: (data: any) => {
      //post返回的结果
      // setOMIM(datas)

      if (data && data.verdict) {
        setCnvMosaic(data)
      }
    }
  })

  const fetchCnvChimerismMosaismData = useMutation({
    mutationFn: async (id: number) => await getCnvChimerismMosaismData(id),
    onSuccess: (data: {
      sustainedRegions: any[]
      sustainedRegionsPng: string
    }) => {
      //post返回的结果
      // setOMIM(datas)

      if (data && data.sustainedRegionsPng && data.sustainedRegions) {
        setCnvChimerismMosaismPng(data.sustainedRegionsPng)

        setCnvChimerismMosaism(data.sustainedRegions)
      }
    }
  })

  const handleGetAssumeRole = useMutation({
    mutationFn: async () => await assumeRole()
  })

  const handleExportSmallVariants = useMutation({
    mutationFn: async (params: any) => await exportSmallVariants(params),
    onSuccess: (data, params) => {
      if (data && data.url) {
        const downloadLink = document.createElement('a')

        downloadLink.href = data.url

        downloadLink.download = `${analysisInfo.name}` as string

        document.body.appendChild(downloadLink)

        downloadLink.click()

        document.body.removeChild(downloadLink)
      }
    }
  })

  const handleGetSignedUrl = useMutation({
    mutationFn: async (data: {
      type: OssSignedUrlType
      obj: string
      prefix: string
    }) =>
      await getSignedUrl({
        type: data.type,
        obj: data.obj,
        fileName: `${analysisInfo.name}${data.prefix}`
      }),
    onSuccess: (data, params) => {
      if (data && data.signedUrl) {
        // window.open(data.signedUrl)
        //
        const downloadLink = document.createElement('a')
        downloadLink.href = data.signedUrl
        downloadLink.download = `${analysisInfo.name}${params.prefix}` as string
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      }
    }
  })

  const handleOss = async () => {
    // 向您搭建的STS服务获取临时访问凭证。
    const query = await handleGetAssumeRole.mutateAsync()

    // if (!query || !query.SecurityToken) return
    const client = new OSS({
      // yourRegion填写Bucket所在地域。
      region: 'oss-cn-shenzhen',

      // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
      accessKeyId: query.AccessKeyId,
      accessKeySecret: query.AccessKeySecret,

      // 从STS服务获取的安全令牌（SecurityToken）。
      stsToken: query.SecurityToken,

      // 刷新临时访问凭证的时间间隔，单位为毫秒。
      refreshSTSTokenInterval: 200000,

      // 填写Bucket名称。
      bucket: 'glsofort',
      refreshSTSToken: async () => {
        const query = await handleGetAssumeRole.mutateAsync()

        //

        return {
          accessKeyId: query.AccessKeyId,
          accessKeySecret: query.AccessKeySecret,
          stsToken: query.SecurityToken
        }
      }
    })

    return client
  }

  const exportVariantsList = (data: any[]) => {
    if (!data.length) return

    const column = Object.getOwnPropertyNames(data[0])
    const arr = data.map((item: any) => {
      const obj: NObject = {}

      column.map((i) => {
        if (typeof item[i] === 'object') obj[i] = JSON.stringify(item[i])
        else obj[i] = item[i]
      })

      return obj
    })

    messageRef?.current?.handleClick(t('Export success'), 'success')

    // 导出XLSX
    const worksheet = XLSX.utils.json_to_sheet(arr)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    XLSX.writeFile(
      workbook,
      `${analysisInfo.name}-${formatDate(new Date())}.xlsx`
    )
  }

  const exportVariantsListXlsx = (data: any[]) => {
    if (!data.length) return

    const column = Object.getOwnPropertyNames(data[0])
    const arr = data.map((item: any) => {
      const obj: NObject = {}

      column.map((i) => {
        if (typeof item[i] === 'object') obj[i] = JSON.stringify(item[i])
        else obj[i] = item[i]
      })

      return obj
    })

    messageRef?.current?.handleClick(t('Export success'), 'success')

    // 导出XLSX
    const worksheet = XLSX.utils.json_to_sheet(arr)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    XLSX.writeFile(
      workbook,
      `${analysisInfo.name}-${formatDate(new Date())}.xlsx`
    )
  }

  const exportAll = async () => {
    const data = await exportAllVariantToCsvs.mutateAsync({
      id: id as unknown as number,
      type: chipQuery.key === '0' ? 'fast_track' : 'snv'
    })

    if (data) {
      const fileURL = URL.createObjectURL(data)

      // 创建一个下载链接

      const downloadLink = document.createElement('a')

      downloadLink.href = fileURL

      downloadLink.download = `${type}_${id}.zip`

      document.body.appendChild(downloadLink)

      downloadLink.click()

      document.body.removeChild(downloadLink)
    }
  }

  const { data: analysis, refetch: refetchAnalyzeInfo } = useQuery<{
    list: Sample[]
  }>({
    queryKey: ['analyzeInfoBySampleId', id],
    queryFn: () => fetchInfoBySampleId(id),
    keepPreviousData: true,
    onSuccess: async (sample) => {
      if (sample.list && sample.list.length) {
        setSampleList(
          sample.list.map((sample: Sample) => {
            if (sample.terms && isJson(sample.terms as string)) {
              sample.terms = JSON.parse(sample.terms as string) as any[]
            } else {
              sample.terms = []
            }

            const hpo_ids = sample.terms
              ?.filter((i) => i && i.hpo_code)
              .map((i) => i.hpo_code)

            if (hpo_ids.length) fetchGeneByHpoIds.mutateAsync(hpo_ids)

            return sample
          })
        )

        if (sample.list[0].hasROH) {
          // const data = await getHomRegions.mutateAsync(id as unknown as string)

          // setMegabase({
          //   megabasePercentage: data.roh.megabasePercentage,
          //   totalMegabase: data.roh.totalMegabase,
          //   imageUrl: data.roh.imageUrl
          // })

          await fetchSampleSamples.mutateAsync({
            sampleId: id
          })

          await getRohLists()
        }

        const analysisInfo = {
          name: sample.list[0].name,
          genomeBuild: sample.list[0].genomeBuild,
          id: sample.list[0].id,
          project: sample.list[0].project?.name,
          projectId: sample.list[0].project?.id,
          gender: sample.list[0].gender,
          patientGender: sample.list[0].patients
            ? sample.list[0].patients[0]?.gender
            : null,
          genderPredictV2: sample.list[0].genderPredictV2
            ? sample.list[0].genderPredictV2
            : null,
          patientName: sample.list[0].patients
            ? sample.list[0].patients[0]?.patientName
            : null,
          area: sample.list[0].geneSet?.name,
          status: sample.list[0].status,
          isReview: sample.list[0].isReview,
          vcfFile: sample.list[0].vcfFile,
          clinicalInformation: sample.list[0].clinicalInformation,
          hasThalassemiaVariants: sample.list[0].hasThalassemiaVariants,
          hasExomeDepthCnv: sample.list[0].hasExomeDepthCnv,
          pipelineVersion: sample.list[0].pipelineVersion,
          terms: sample.list[0].terms,
          bamFile: sample.list[0].bamFile,
          prefix: sample.list[0].prefix,
          avgReadDepth: sample.list[0].avgReadDepth,
          avgExonReadDepth: sample.list[0].avgExonReadDepth,
          avgIntronReadDepth: sample.list[0].avgIntronReadDepth,
          hasRoh: sample.list[0].hasROH,
          hasSCIP: sample.list[0].hasSCIP,
          hasHLA: sample.list[0].hasHLA,
          hasSMN: sample.list[0].hasSMN,
          sampleType: sample.list[0].sampleType,
          vcfType: sample.list[0].vcfType,
          cnvBatchStatus: sample.list[0].cnvBatchStatus,
          freemixScore: sample.list[0].freemixScore,
          cnvManualStatus: sample.list[0].cnvManualStatus,
          samples: sample.list
        }
        const user = sample.list[0].user

        //

        if (
          user &&
          user.vcfSource &&
          user.vcfSource === VcfSource.HUADA &&
          sample.list[0].genderPredictV2
        ) {
          analysisInfo.gender = sample.list[0].genderPredictV2
        }

        if (analysisInfo.pipelineVersion && analysisInfo.hasExomeDepthCnv) {
          const data = await findGlsCnvManual.mutateAsync({
            type: 'cnv_recurate',
            sample_id: id as string
          })

          if (data && data.data && data.data.length) {
            analysisInfo.cnvManualStatus = data.data.some(
              (i) => i.status === 'processing'
            )
              ? AdvancedTaskStatus.PROCESSING
              : AdvancedTaskStatus.PROCESSED
          }

          setAnalysisInfo(analysisInfo)
        } else {
          setAnalysisInfo(analysisInfo)
        }

        if (analysisInfo.vcfType && analysisInfo.vcfType === 'microarray') {
          const index = '1'

          setChips(
            chips.map((items) => {
              items.checked = false

              if (items.key === index) {
                items.checked = true
              }

              return items
            })
          )
        }
      }
    }
  })

  React.useEffect(() => {
    if (id && type) {
      getReportsVariants.mutateAsync({
        objectId: id as string,
        objectType: type
      })
    }
  }, [id, type])

  const getReportsVariants = useMutation({
    mutationFn: async (data: { objectId: string; objectType: string }) => {
      //

      return await getVariantReports2(data as any)
    },
    onSuccess: (data: any) => {
      if (data.list && data.list.length) {
        //
        const list = data.list[0].snvVariants

        setSelectReportRowKey(list)

        setReportVariantId(data.list[0].id)

        setMenuList(
          menuList.map((items) => {
            const temp = list.filter(
              (item: any) => item.variantsType === items.key
            )

            items.value = temp

            items.variantReportsId = data.list[0].id

            return items
          })
        )
      } else
        setMenuList(
          menuList.map((items) => {
            items.value = []

            return items
          })
        )
    },
    mutationKey: ['reportsVariants']
  })

  const getRohLists = async () => {
    if (analysisInfo.pipelineVersion) {
      const data = await getGlsRohList.mutateAsync(id as unknown as number)

      const list = await Promise.all(
        data.regions.map(async (item: any, index: number) => {
          // let GeneImprintData = []

          // //

          // if (analysisInfo.genomeBuild === 'hg38') {
          //   GeneImprintData = await getGeneImprintData.mutateAsync({
          //     genomeVersion: 'hg38',
          //     chromosome: item.chrom,
          //     startPosition: Number(item.begin),
          //     endPosition: Number(item.end)
          //   })
          // } else {
          //   GeneImprintData = await getGeneImprintData.mutateAsync({
          //     genomeVersion: 'hg19',
          //     chromosome: item.chrom,
          //     startPosition: Number(item.begin),
          //     endPosition: Number(item.end)
          //   })
          // }

          // if (GeneImprintData && GeneImprintData.length) {
          //   item.GeneImprintData = GeneImprintData
          // }

          item.index = index
          item.chrom = item.chromosome
          const temp = item.chromosome.split('chr')

          item.chromIndex =
            temp && temp.length === 2 ? Number(temp[1]) : item.chromosome

          item.begin = Number(item.begin) as unknown as string

          item.end = Number(item.end) as unknown as string

          item.size = Number(item.size_mb) as unknown as string

          item.nbVariants = Number(item.nb_variants) as unknown as string

          item.percentageHomozygosity = Number(
            item.percentage_homozygosity
          ) as unknown as string

          return item
        })
      )

      setRohList(list)
      return
    }
    const data = await getRohList.mutateAsync(id as unknown as number)

    data.data.shift()

    const list = await Promise.all(
      data.data.map(async (item: any, index) => {
        // let GeneImprintData = []

        // //

        // if (analysisInfo.genomeBuild === 'hg38') {
        //   GeneImprintData = await getGeneImprintData.mutateAsync({
        //     genomeVersion: 'hg38',
        //     chromosome: item.chrom,
        //     startPosition: Number(item.begin),
        //     endPosition: Number(item.end)
        //   })
        // } else {
        //   GeneImprintData = await getGeneImprintData.mutateAsync({
        //     genomeVersion: 'hg19',
        //     chromosome: item.chrom,
        //     startPosition: Number(item.begin),
        //     endPosition: Number(item.end)
        //   })
        // }

        // if (GeneImprintData && GeneImprintData.length) {
        //   item.GeneImprintData = GeneImprintData
        // }

        item.index = index
        const temp = item.chrom.split('chr')

        item.chromIndex =
          temp && temp.length === 2 ? Number(temp[1]) : item.chrom

        item.begin = Number(item.begin) as unknown as string

        item.end = Number(item.end) as unknown as string

        item.size = Number(item.size) as unknown as string

        item.nbVariants = Number(item.nbVariants) as unknown as string

        item.percentageHomozygosity = Number(
          item.percentageHomozygosity
        ) as unknown as string

        return item
      })
    )

    setRohList(list)
  }

  const getFastTrackData = useMutation({
    mutationFn: async (data: NObject) =>
      await getVariantsByFastTrack(data, Number(id))
  })

  const getGlsFastTrackData = useMutation({
    mutationFn: async (data: any) => await getGlsVariants(data)
  })

  const getGeneImprintData = useMutation({
    mutationFn: async (data: GeneImprint | Pagination) =>
      await getGeneImprint(data),
    onSuccess: async (data: GeneImprint[]) => {
      if (data && data.length) {
        const geneNames = data.map((i) => i.geneName) as string[]

        if (geneNames) {
          const OMIMs: VariantDetailOmimData[] = await getOMIM.mutateAsync({
            geneNames
          })

          const list = data.map((items: any) => {
            const tempOMIM = OMIMs.find(
              (item) => item.geneName === items.geneName
            )

            if (tempOMIM) {
              items.OMIMCN = `${unique(tempOMIM?.omimData ?? [], 'phenoName')
                .map((item: any) => {
                  const inheritances: string[] = []

                  if (
                    item &&
                    item.clinicalSynopsis &&
                    item.clinicalSynopsis.INHERITANCE &&
                    Array.isArray(item.clinicalSynopsis.INHERITANCE)
                  ) {
                    item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                      inheritances.push(str.toLowerCase())
                    )
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    item.inheritance =
                      inheritance || inheritance !== ''
                        ? inheritance
                        : Array.from([
                            ...new Set(item.clinicalSynopsis.INHERITANCE)
                          ]).join(',')
                  }

                  return `${item.inheritance}-${item.pheno_name_cn}`
                })
                .filter((item) => item)
                .join(',')}`

              items.OMIMEN = `${unique(tempOMIM?.omimData ?? [], 'phenoName')
                .map((item: any) => {
                  const inheritances: string[] = []

                  if (
                    item &&
                    item.clinicalSynopsis &&
                    item.clinicalSynopsis.INHERITANCE &&
                    Array.isArray(item.clinicalSynopsis.INHERITANCE)
                  ) {
                    item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                      inheritances.push(str.toLowerCase())
                    )
                    const inheritance = formatVariantInheritance(
                      Array.from([...new Set(inheritances)]).join(',')
                    )

                    item.inheritance =
                      inheritance || inheritance !== ''
                        ? inheritance
                        : Array.from([
                            ...new Set(item.clinicalSynopsis.INHERITANCE)
                          ]).join(',')
                  }

                  return `${item.inheritance}-${item.phenoName}`
                })
                .filter((item) => item)
                .join(',')}`

              items.clinicalSynopsis = unique(
                tempOMIM?.omimData ?? [],
                'phenoName'
              )
            }

            return items
          })

          setGeneImprintData(list)
        }
      }
    }
  })

  const getStrDatas = useMutation({
    mutationFn: async (data: NObject) => await getSTRData(data, Number(id))
  })

  const getGlsStrDatas = useMutation({
    mutationFn: async (data: any) => await getGlsVariants(data)
  })

  const getOMIM = useMutation({
    mutationFn: async (data: { geneNames: string[] }) =>
      await fetchOMIM({ geneNames: data.geneNames }),
    onSuccess: async (datas: VariantDetailOmimData[], params) => {
      //post返回的结果
    }
  })

  const fetchBamUrl = useMutation({
    mutationFn: async (id: any) => await getBamUrl(id)
  })

  const editSampleStatus = useMutation({
    mutationFn: async (data: Sample) => await editSample(data),
    onSuccess: (data: Sample) => {
      //post返回的结果
      refetchAnalyzeInfo()
    }
  })

  const editSamples = useMutation({
    mutationFn: async (data: Sample) => await editSample(data),
    onSuccess: (data: Sample) => {
      //post返回的结果
    }
  })

  const getHomRegions = useMutation({
    mutationFn: async (id: string) => await getQCData(id),
    onError: (error: any) => {
      //

      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.statusCode === 401
      ) {
        router.push(`/401`)
      }
    }
  })

  const createSampleSample = useMutation({
    mutationFn: async (params: SampleLabels) =>
      await createSampleSamples(params)
  })

  const deleteSampleSample = useMutation({
    mutationFn: async (id: number) => await deleteSampleSamples(id)
  })

  const fetchSampleSamples = useMutation({
    mutationFn: async (params: any) => await getSampleSamples(params),
    onSuccess: (data) => {
      //post返回的结果

      setSampleLabel(data)
    }
  })

  const exportAllVariantToCsvs = useMutation({
    mutationFn: async (data: { id: number; type: string }) =>
      await exportAllVariantToCsv(data),
    onSuccess: (data) => {
      //post返回的结果
      // refetch()
      //
    }
  })

  const fetchGeneByHpoIds = useMutation({
    mutationFn: async (data: string[]) =>
      await getGeneByHpoIds({
        hpoIds: data
      }),
    onSuccess: (data) => {
      //

      if (data && Array.isArray(data) && data.length) {
        setGeneList(data)
      }
    }
  })

  const Translate = useMutation({
    mutationFn: async (data: TranslateDto) => await translate(data)
  })

  const getRohList = useMutation({
    mutationFn: async (id: number) => await fetchRohList(id),
    onSuccess: (data: IVariantRohList) => {
      //post返回的结果
      // //
      // data.data.shift()
      // setRohList(
      //   data.data.map((item, index) => {
      //     item.index = index
      //     item.begin = Number(item.begin) as unknown as string
      //     item.end = Number(item.end) as unknown as string
      //     return item
      //   })
      // )
      // setRohOpen(true)
    }
  })

  const getGlsRohList = useMutation({
    mutationFn: async (id: number) =>
      await getGlsRoh({ id: id as unknown as string }),
    onSuccess: (data) => {
      //post返回的结果
    }
  })

  const addReportVariants = useMutation({
    mutationFn: async (data: ReportsVariants) =>
      await createVariantReports(data),
    onSuccess: (data: ReportsVariants) => {
      //post返回的结果
      // refetch()
      //
    }
  })

  const editReportVariant = useMutation({
    mutationFn: async (data: ReportsVariants) => await editVariantReports(data)
  })

  const Articles = useMutation({
    mutationFn: async (data: GetArticlesDto) => await getArticles(data)
  })

  const delayedArticlesRequest = async (data: GetArticlesDto, delay = 0) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        getArticles(data)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, delay)
    })
  }

  const delayedVariantDetailRequest = async (data: Variation, delay = 0) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const variants = {
          chrom: data.chrom,
          pos: data.pos,
          REF: data.REF,
          ALT: data.ALT,
          gene: data.gene,
          genomeBuild: analysisInfo.genomeBuild
        }

        fetchVariantDetails({
          sampleId: id as unknown as number,
          variants
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, delay)
    })
  }

  const delayedTranslateRequest = async (data: TranslateDto, delay = 0) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        translate(data)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }, delay)
    })
  }

  const getVariantDetail = useMutation({
    mutationFn: async (params: Variation) => {
      const variants = {
        chrom: params.chrom,
        pos: params.pos,
        REF: params.REF,
        ALT: params.ALT,
        gene: params.gene,
        genomeBuild: analysisInfo.genomeBuild
      }

      return await fetchVariantDetails({
        sampleId: id as unknown as number,
        variants
      })
    }
  })

  const download = useMutation({
    mutationFn: async (key: string) =>
      await downLoad({
        fileKey: key
      }),
    onSuccess: (data: any) => {
      //post返回的结果
      handleCsvClose()

      messageRef?.current?.handleClick(t('Download successful'), 'success')

      //

      // 处理响应数据
      data = Buffer.from(data, 'binary')
      const file = new Blob([data.data], { type: 'application/octet-stream' })

      const fileURL = URL.createObjectURL(file)

      // 创建一个下载链接

      const downloadLink = document.createElement('a')

      downloadLink.href = fileURL

      downloadLink.download = analysisInfo.vcfFile as string

      document.body.appendChild(downloadLink)

      downloadLink.click()

      document.body.removeChild(downloadLink)
    },
    onError: (error) => {
      messageRef?.current?.handleClick(t('Download failed') + error, 'error')
    }
  })

  const download2 = useMutation({
    mutationFn: async (params: { parent: string; filename: string }) =>
      await downLoad2(params),
    onSuccess: (data: any) => {
      //post返回的结果
      if (data && data.buffer && data.buffer.data) {
        messageRef?.current?.handleClick(t('Download successful'), 'success')

        //

        // 处理响应数据
        const datas = Buffer.from(data.buffer, 'binary')
        const file = new Blob([datas as any], {
          type: 'application/octet-stream'
        })

        const fileURL = URL.createObjectURL(file)

        // 创建一个下载链接

        const downloadLink = document.createElement('a')

        downloadLink.href = fileURL

        downloadLink.download = data.filename

        document.body.appendChild(downloadLink)

        downloadLink.click()

        document.body.removeChild(downloadLink)
      }
    },
    onError: (error) => {
      messageRef?.current?.handleClick(t('Download failed') + error, 'error')
    }
  })

  const currentRohList = React.useMemo(() => {
    const list = rohList
      .filter(
        (item) =>
          item &&
          item.size &&
          Number(item.size) > rohFilterValue.size &&
          item.nbVariants &&
          Number(item.nbVariants) > rohFilterValue.nbVariants &&
          item.percentageHomozygosity &&
          Number(item.percentageHomozygosity) >
            rohFilterValue.percentageHomozygosity
      )
      .map((items: any, index) => {
        // const chroms = rohList
        //   .filter((item) => item.chrom === items.chrom)
        //   .map((item) => Number(item.size) * 1000000)

        const Size = Number(items.size)

        // const chromSize = chroms.reduce(
        //   (accumulator, currentValue) => accumulator + Number(currentValue),
        //   0
        // )

        const temp = chromSizes.find((item) => item.chrom === items.chrom)
        let isUPD = false

        if (temp) {
          isUPD = Size / (temp.size / 1000000) > 0.05
        }

        if (GeneImprintData && GeneImprintData.length) {
          const list = GeneImprintData.filter(
            (item) =>
              item.chromosome === items.chrom &&
              item.startPosition &&
              item.endPosition &&
              Number(item.startPosition) >= Number(items.begin) &&
              Number(item.endPosition) <= Number(items.end)
          )

          //

          if (list) {
            items.GeneImprintData = list.map((item) => {
              const obj = {
                ...item,
                Coverage: `0%`
              }

              obj.Coverage = calculateCoverage(
                [Number(item.startPosition), Number(item.endPosition)],
                [Number(items.begin), Number(items.end)]
              ).coveragePercentage

              return obj
            })
          }
        }

        return {
          ...items,
          Size,
          isUPD,
          index,
          id: `${items.chrom}_${items.begin}_${items.end}`
        }
      })

    //

    return list
  }, [rohFilterValue, rohList, GeneImprintData])

  const RohUpd = React.useMemo(() => {
    return (
      unique(
        currentRohList.filter((item) => item.isUPD),
        'chrom'
      )
        .map((item) => item.chrom)
        .join(',') ?? ''
    )
  }, [currentRohList])

  const backop = React.useMemo(() => {
    return !(Object.keys(analysisInfo).length ? true : false)
  }, [analysisInfo])

  if (!analysis || !analysis.list || !analysis.list.length) return null

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={backop}
        id="backdrop"
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          paddingRight: 4,
          paddingLeft: 4
        }}
        id="header2"
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          paddingRight={2}
          justifyContent="space-between"
        >
          <Grid
            item
            display="flex"
            alignItems={'center'}
            width="100%"
            justifyContent={'space-between'}
            xs={isWindow() ? 4 : 12}
          >
            <Box
              sx={{
                display: 'flex'
              }}
              width="100%"
            >
              {isWindow() && (
                <IconButton
                  onClick={() => {
                    router.push('/samples/')
                  }}
                  color="secondary"
                  aria-label="add an alarm"
                >
                  <ArrowBackIcon />
                </IconButton>
              )}

              <TabSelected
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                <Tab
                  sx={{
                    textTransform: 'capitalize'
                  }}
                  label={t('Patient information')}
                  {...a11yProps(0)}
                />

                <Tab
                  sx={{
                    textTransform: 'capitalize'
                  }}
                  label={t('Quality control')}
                  {...a11yProps(1)}
                />

                <Tab
                  sx={{
                    textTransform: 'capitalize'
                  }}
                  label={t('variant')}
                  {...a11yProps(2)}
                  disabled={analysisInfo.status === 'created'}
                />

                <Tab
                  sx={{
                    textTransform: 'capitalize'
                  }}
                  label={t('report')}
                  {...a11yProps(3)}
                  disabled={analysisInfo.status === 'created'}
                />

                {/* <Tab
                label={t('Quality control')}
                {...a11yProps(3)}
                disabled={analysisInfo.status === 'created'}
              /> */}
              </TabSelected>
            </Box>
          </Grid>

          {/* // ========== JSX 部分 ========== */}
          {isWindow() && (
            <Grid container item xs={8} justifyContent="flex-end">
              {/* Sample Labels 区块 */}
              <Grid item sx={{ mr: 1 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  {!sampleLabel.length && (
                    <Chip
                      sx={{ maxWidth: 150, borderRadius: '4px' }}
                      label={`${t('Tag')}:`}
                      onClick={handleLabelClick}
                    />
                  )}

                  {sampleLabel.map((item, index) => (
                    <Tooltip
                      title={`${t('Tag')}: ${item.labelName}`}
                      placement="top-start"
                      key={item.labelName}
                    >
                      <Chip
                        sx={{ maxWidth: 200, borderRadius: '4px' }}
                        color={
                          index === 0
                            ? 'primary'
                            : index === 1
                            ? 'warning'
                            : index === 2
                            ? 'success'
                            : 'secondary'
                        }
                        label={`${t('Tag')}: ${item.labelName}`}
                        onClick={handleLabelClick}
                      />
                    </Tooltip>
                  ))}
                </Stack>
              </Grid>

              {/* 信息 Chips 区块 */}
              <Grid item>
                <Stack direction="row" spacing={2} alignItems="center">
                  {/* Name */}
                  <InfoChip
                    label={`${t('Name')}:${analysisInfo.name}`}
                    tooltip={analysisInfo.name}
                  />

                  {/* Patient Name (可点击) */}
                  <InfoChip
                    label={`${t('Patient Name')}:${
                      analysisInfo.patientName ?? '-'
                    }`}
                    onClick={() => setPhenotypeOpen(true)}
                  />

                  {/* Genome Build */}
                  <InfoChip
                    label={`${t('Genome build')}:${analysisInfo.genomeBuild}`}
                    keys={'genomeBuild'}
                    onClick={
                      ((e: any) =>
                        setAnchorGenomeBuildEl(e.currentTarget)) as any
                    }
                    icon={<ArrowDropDown />}
                  />

                  {/* Project */}
                  <InfoChip
                    label={`${t('project')}:${analysisInfo.project ?? '-'}`}
                  />

                  {/* Bed */}
                  <InfoChip
                    label={`${t('Bed')}:${analysisInfo.area ?? '-'}`}
                    tooltip={`${t('Bed')}:${analysisInfo.area ?? '-'}`}
                  />

                  {/* Contamination */}
                  {(() => {
                    const info = getContaminationInfo(analysisInfo.freemixScore)
                    return (
                      <InfoChip
                        color={info.color}
                        label={`${t('Contamination')}:${info.label}`}
                      />
                    )
                  })()}

                  {/* Gender Prediction */}
                  {(() => {
                    const { mismatch, predictedGender } =
                      getGenderWarning(analysisInfo)
                    return (
                      <InfoChip
                        color={mismatch ? 'error' : 'default'}
                        icon={
                          mismatch ? (
                            <WarningAmberRounded color="error" />
                          ) : undefined
                        }
                        label={`${t('Gender')} ${t(
                          'Prediction'
                        )}:${predictedGender}`}
                      />
                    )
                  })()}
                </Stack>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>

      <TabPanel value={value} index={1}>
        <Box height={'100%'}>
          <QualityControl isSample={true} analysisInfo={analysisInfo} />
        </Box>
      </TabPanel>

      <TabPanel value={value} index={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} paddingTop={'5px !important'}>
            <Grid container sx={{ flexWrap: 'nowrap' }}>
              <Grid item sx={{ width: '100%' }}>
                <Grid
                  container
                  id="header3"
                  alignItems={'center'}
                  margin={'5px 0'}
                >
                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                  >
                    <Grid container justifyContent={'space-between'}>
                      <Grid item xs={isWindow() ? 5.5 : 12}>
                        <Stack
                          direction={'row'}
                          spacing={2}
                          alignItems="center"
                        >
                          <Stack
                            direction={'row'}
                            px={4}
                            py={1}
                            bgcolor={'rgba(224,224,224)'}
                            spacing={2}
                            alignItems={'center'}
                            useFlexGap
                            sx={{ flexWrap: 'wrap' }}
                          >
                            {chipList
                              .filter((item) => {
                                if (
                                  !sampleList?.some(
                                    (sample) =>
                                      sample.hasCnv ||
                                      (sample.cnvBatchTaskId &&
                                        sample.cnvBatchStatus ===
                                          'processed') ||
                                      sample.hasExomeDepthCnv
                                  )
                                ) {
                                  return item.title !== 'CNV'
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some((sample) => sample.hasSv)
                                ) {
                                  return item.title !== 'SV'
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some((sample) => sample.hasSTR)
                                ) {
                                  return item.title !== 'STR'
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some(
                                    (sample) => sample.hasThalassemiaVariants
                                  )
                                ) {
                                  return item.title !== t('thalassemia')
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some(
                                    (sample) =>
                                      sample.hasHLA &&
                                      sample.deactivatedPlugins?.includes(
                                        NfPlugins.HLA
                                      ) !== true
                                  )
                                ) {
                                  return item.title !== t('HLA')
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some(
                                    (sample) => sample.hasThalassemiaVariants
                                  )
                                ) {
                                  return item.title !== `${t('thal plot')}`
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  !sampleList?.some((sample) => sample.hasROH)
                                ) {
                                  return item.title !== 'ROH'
                                }

                                return true
                              })
                              .filter((item) => {
                                if (
                                  sampleList?.some(
                                    (sample) => sample.vcfType === 'microarray'
                                  )
                                ) {
                                  return item.title === 'SNV/INDEL'
                                }

                                return true
                              })
                              .map((items) => {
                                return (
                                  <Button
                                    variant={
                                      chipQuery.key === items.key ||
                                      (items.key === '3' && isRoh)
                                        ? 'contained'
                                        : 'contained'
                                    }
                                    onClick={async () => {
                                      if (items.title === 'ROH') {
                                        handleChip1Click('1')

                                        setRohOpen(true)

                                        // if (
                                        //   analysisInfo.genomeBuild === 'hg38'
                                        // ) {
                                        //   await getGeneImprintData.mutateAsync({
                                        //     genomeVersion: 'hg38'
                                        //   })
                                        // } else {
                                        //   await getGeneImprintData.mutateAsync({
                                        //     genomeVersion: 'hg19'
                                        //   })
                                        // }

                                        await getRohLists()
                                      } else if (items.title === t('HLA')) {
                                        handleChip1Click(items.key)
                                        if (id) {
                                          fetchGlsHlaData.mutateAsync({
                                            id: id as unknown as string
                                          })
                                        }
                                      } else handleChip1Click(items.key)
                                    }}
                                    key={items.key}
                                    color={
                                      chipQuery.key === items.key ||
                                      (items.key === '3' && isRoh)
                                        ? 'primary'
                                        : 'inherit'
                                    }
                                    size="small"
                                    sx={{
                                      height: '28px',
                                      borderRadius: '4px'
                                    }}
                                  >
                                    {items.title}

                                    <Tooltip
                                      placement="top-start"
                                      title={
                                        <Box>
                                          <Typography color={'white'}>
                                            {`条件 1：
分类：致病 (pathogenic)、可能致病 (likely pathogenic)、意义不明 (uncertain significance)、功能丧失 (loss of function)
序列本体论：移码 (frameshift)、移码内缺失/插入 (inframe indel)、错义变异 (missense)、起始密码子丢失 (start lost)、起始密码子保留 (start retained)、终止密码子生成 (stopgain)、终止密码子丢失 (stoploss)、终止密码子保留 (stop retained)、编码区 (coding)、蛋白质改变变异 (Protein altering variant)、剪接 (splicing)、剪接受体位点 (splice_acceptor)、剪接供体位点 (splice_donor)
拥有OMIM基因
读取深度 >= 10
等位基因频率 (AF) > 0.2 quality score > 190
ACMG分类：意义不明 (Uncertain significance)、可能致病 (Likely pathogenic)、致病 (Pathogenic)
`}
                                          </Typography>

                                          <Typography color={'white'}>
                                            {`
条件 2：
序列本体论：非编码区 (Noncoding)
分类：药物反应 (drug response)、致病 (pathogenic)、可能致病 (likely pathogenic)`}
                                          </Typography>
                                        </Box>
                                      }
                                    >
                                      {items.key === '0' ? (
                                        <InformationOutline fontSize="small" />
                                      ) : (
                                        <></>
                                      )}
                                    </Tooltip>
                                  </Button>
                                )
                              })}
                          </Stack>

                          {isWindow() && (
                            <>
                              <FilterSelect setFilterToggle={setFilterToggle} />

                              <Tooltip
                                title={`颜色编码变异的关键是：
      • 红色变异以前被报告为致病性（P）或致病性。
      • 浅红色可能是致病性（LP）变体
      •黄色是在致病基因中发现的功能丧失（LOF）
      • 灰色变体是指意义未知或不确定（VUS）的变体。
      • 蓝色和浅蓝色分别代表良性和可能的良性变异（B/LB）
      • 绿色是指与药物反应或治疗相关的变体。`}
                              >
                                <IconButton
                                  color="inherit"
                                  aria-haspopup="true"
                                  onClick={() => {
                                    setColorToggle(!colorToggle)
                                  }}
                                >
                                  {colorToggle ? (
                                    <FormatColorHighlight />
                                  ) : (
                                    <FormatColorMarkerCancel />
                                  )}
                                </IconButton>
                              </Tooltip>

                              <Tooltip title={t('是否展示index')}>
                                <Switch
                                  checked={indexChecked}
                                  onChange={(e) => {
                                    setIndexChecked(e.target.checked)
                                  }}
                                />
                              </Tooltip>
                            </>
                          )}

                          {analysisInfo.cnvBatchStatus === 'analyzing' ? (
                            <Button
                              variant="contained"
                              size="small"
                              color={'success'}
                            >
                              {t('The CNV is being generated')}
                            </Button>
                          ) : (
                            ''
                          )}
                        </Stack>
                      </Grid>

                      {isWindow() && (
                        <Grid item xs={6.5}>
                          <Stack
                            spacing={{ xs: 1, sm: 2 }}
                            direction="row"
                            useFlexGap
                            flexWrap="wrap"
                            alignItems={'center'}
                            justifyContent="flex-end"
                          >
                            {/* <Button
                          size="small"
                          variant="outlined"
                          startIcon={<Restore />}
                          sx={{ marginRight: '10px' }}
                          onClick={handleReset}
                        >
                          {`${t('reset')}`}
                        </Button> */}

                            {chipQuery &&
                            !chipQuery.title?.includes(t('thalassemia')) ? (
                              <Box>
                                <Button
                                  variant={
                                    isFiltering ? 'contained' : 'outlined'
                                  }
                                  onClick={toggleDrawer}
                                  startIcon={<FilterOutline />}
                                  color={isFiltering ? 'primary' : 'secondary'}
                                >
                                  {t('Filters')}

                                  {drawerOpen ? <Close fontSize="small" /> : ''}
                                </Button>

                                <Fade in={drawerOpen}>
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      right: '0.5%',
                                      height: isWindow() ? '73vh' : '60vh',
                                      overflow: 'auto',
                                      zIndex: 9999,
                                      overflowX: 'hidden',
                                      bgcolor: 'white'
                                    }}
                                    boxShadow={
                                      '-4px 0px 20px 0px rgba(7, 54, 64, 0.39)'
                                    }
                                  >
                                    <FilterList
                                      ref={filterRef}
                                      fn={(config: any) => {
                                        setConfig(config)
                                        if (config) {
                                          setIsFiltering(true)
                                        } else {
                                          setIsFiltering(false)
                                        }
                                      }}
                                      filterType={chipQuery}
                                      handleChip1Click={handleChip1Click}
                                      close={setDrawerOpen}
                                      analysisInfo={analysisInfo}
                                    />
                                  </Box>
                                </Fade>
                              </Box>
                            ) : (
                              ''
                            )}

                            {value === 2 &&
                            selectRowKey.length &&
                            ability.can('report', 'sample-page_sample') ? (
                              <Box>
                                <Button
                                  onClick={handleClickOpen}
                                  variant="outlined"
                                  sx={{ mr: 2 }}
                                  startIcon={<PlusBox />}
                                  color={'secondary'}
                                >
                                  {t('Add to...')}
                                </Button>

                                <Button
                                  id="click-menu"
                                  variant="outlined"
                                  startIcon={<PlusBox />}
                                  onClick={handleMenuClick}
                                  color={'secondary'}
                                >
                                  {t('Add to report')}
                                </Button>
                              </Box>
                            ) : null}

                            {chipQuery &&
                            chipQuery.title === 'CNV' &&
                            selectRowKey.length ? (
                              <Button
                                id="click-menu"
                                variant="outlined"
                                startIcon={<PlusBox />}
                                onClick={() => {
                                  createCnvManual()
                                  setCnvManualFormOpen(true)
                                }}
                                color={'secondary'}
                              >
                                {t('合并')}
                              </Button>
                            ) : (
                              ''
                            )}

                            {chipQuery && chipQuery.title === 'CNV' ? (
                              <Tooltip
                                title={
                                  analysisInfo.cnvManualStatus
                                    ? t(analysisInfo.cnvManualStatus)
                                    : ''
                                }
                              >
                                <Button
                                  id="click-menu"
                                  variant="outlined"
                                  startIcon={<PlusBox />}
                                  onClick={handleCnvManual}
                                  color={'secondary'}
                                >
                                  {t('Merge List')}
                                </Button>
                              </Tooltip>
                            ) : (
                              ''
                            )}

                            {chipQuery && chipQuery.title === 'CNV' ? (
                              <Tooltip
                                title={
                                  analysisInfo.cnvManualStatus
                                    ? t(analysisInfo.cnvManualStatus)
                                    : ''
                                }
                              >
                                <Button
                                  id="click-menu"
                                  variant="outlined"
                                  startIcon={<PlusBox />}
                                  onClick={handleCnvChimerism}
                                  color={'secondary'}
                                >
                                  {t('CNV chimerism')}
                                </Button>
                              </Tooltip>
                            ) : (
                              ''
                            )}

                            <Box>
                              <Button
                                variant="outlined"
                                startIcon={<Check />}
                                onClick={() => {
                                  if (
                                    ability.can('review', 'sample-page_sample')
                                  )
                                    editSampleStatus.mutateAsync({
                                      id: analysis.list[0].id,
                                      name: analysis.list[0].name,
                                      projectId: analysis.list[0].projectId,
                                      genomeBuild: analysis.list[0].genomeBuild,
                                      gender: analysis.list[0].gender,
                                      status: analysis.list[0].status,
                                      isReview: 1
                                    })
                                }}
                                color={'secondary'}
                              >
                                {!analysisInfo.isReview
                                  ? t('review')
                                  : t('reviewed')}
                              </Button>
                            </Box>

                            <Stack direction={'row'} alignItems="center">
                              {ability.can('download', 'sample-page_sample') ? (
                                <Button
                                  variant="outlined"
                                  onClick={handleCsvMenuClick}
                                  disableElevation
                                  color={'secondary'}
                                  startIcon={<ArrowCollapseDown />}
                                >
                                  {`${t('download')}`}
                                </Button>
                              ) : (
                                ''
                              )}
                            </Stack>

                            <Box>
                              {analysisInfo.sampleType === 'vcf' ? (
                                <Button
                                  variant="outlined"
                                  startIcon={<ArrowExpandUp />}
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() => {
                                    setUpBamOpen(true)
                                  }}
                                  color={'secondary'}
                                >
                                  {`${t('Upload BAM File')}`}
                                </Button>
                              ) : (
                                ''
                              )}
                            </Box>

                            <Box>
                              <Button
                                variant="outlined"
                                startIcon={<ArrowCollapseDown />}
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                onClick={async () => {
                                  // reportsVariantsRefetch()
                                  // setBackOpen(true)

                                  setDownloadReportOpen(true)

                                  // if (id && type)
                                  //   await getReportsVariants.mutateAsync({
                                  //     objectId: id as string,
                                  //     objectType: type
                                  //   })

                                  // setBackOpen(false)
                                }}
                                color={'secondary'}
                              >
                                {`${t('Selected site')}`}
                              </Button>
                            </Box>

                            <Box>
                              <Button
                                variant="outlined"
                                startIcon={<MenuIcon />}
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                onClick={() => {
                                  setVariantOpen(true)
                                }}
                                color={'secondary'}
                              >
                                {`${t('Variant list')}`}
                              </Button>
                            </Box>

                            {/* <Button
                            variant="outlined"
                            onMouseEnter={toggleDrawer}
                            startIcon={<Filter />}
                            size="small"
                            sx={{}}
                          >
                            {t('Filters')}
                          </Button> */}
                          </Stack>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  onClick={() => {
                    setDrawerOpen(false)
                  }}
                  id={'cnv-plot-container'}
                >
                  {chipQuery.title?.includes('CNV') ? (
                    <Box>
                      {sampleList?.some(
                        (sample) =>
                          sample.vcfType !== 'wgs' &&
                          ((sample.cnvBatchTaskId &&
                            sample.cnvBatchStatus === 'processed') ||
                            sample.hasExomeDepthCnv)
                      ) ? (
                        <Box>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                              value={cnvValue}
                              onChange={(e: any, newValue) => {
                                if (e.target.innerText === 'CNV Exon') {
                                  //
                                }

                                setCnvValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              {/* <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV ALL')}
                                {...a11yProps(0)}
                              /> */}

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV Exon')}
                                {...a11yProps(0)}
                              />

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV chart')}
                                {...a11yProps(1)}
                              />

                              {!analysisInfo.pipelineVersion && (
                                <Tab
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                  label={t('Gene display')}
                                  {...a11yProps(2)}
                                />
                              )}
                            </Tabs>
                          </Box>

                          {/* <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              query={chipQuery}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={chipQuery.key}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              colorToggle={colorToggle}
                            />
                          </TabPanel> */}

                          <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              setSelectRowKey={setSelectRowKey}
                              query={{
                                title: 'CNV Exon',
                                checked: true,
                                key: '8'
                              }}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={'8'}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              indexChecked={indexChecked}
                              colorToggle={colorToggle}
                            />
                          </TabPanel>

                          <TabPanel value={cnvValue} index={1}>
                            <Tabs
                              value={cnvAllValue}
                              onChange={(e, newValue) => {
                                setCnvAllValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Exons level')}
                                {...a11yProps(0)}
                              />

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Chr level')}
                                {...a11yProps(1)}
                              />
                            </Tabs>

                            <TabPanel value={cnvAllValue} index={0}>
                              <CnvHG19QcPlot
                                onlyChrom={false}
                                analysisInfo={analysisInfo}
                              />
                            </TabPanel>

                            <TabPanel value={cnvAllValue} index={1}>
                              <CnvKitQcPlot analysisInfo={analysisInfo} />
                            </TabPanel>
                          </TabPanel>

                          <TabPanel value={cnvValue} index={2}>
                            <CnvGeneDisplay
                              data={[]}
                              id={id as unknown as number}
                            />
                          </TabPanel>
                        </Box>
                      ) : sampleList?.some(
                          (sample) => sample.vcfType === 'wes' && sample.hasCnv
                        ) ? (
                        <Box>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                              value={cnvValue}
                              onChange={(e: any, newValue) => {
                                //

                                if (e.target.innerText === 'CNV Exon') {
                                  //
                                }

                                setCnvValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              {/* <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV ALL')}
                                {...a11yProps(0)}
                              /> */}

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV ALL')}
                                {...a11yProps(0)}
                              />

                              {!analysisInfo.pipelineVersion && (
                                <Tab
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                  label={t('Gene display')}
                                  {...a11yProps(1)}
                                />
                              )}
                            </Tabs>
                          </Box>

                          <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              setSelectRowKey={setSelectRowKey}
                              query={chipQuery}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={chipQuery.key}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              indexChecked={indexChecked}
                              colorToggle={colorToggle}
                            />
                          </TabPanel>

                          <TabPanel value={cnvValue} index={1}>
                            <CnvGeneDisplay
                              data={[]}
                              id={id as unknown as number}
                            />
                          </TabPanel>
                        </Box>
                      ) : sampleList?.some(
                          (sample) =>
                            sample.vcfType === 'wgs' &&
                            ((sample.cnvBatchTaskId &&
                              sample.cnvBatchStatus === 'processed') ||
                              sample.hasExomeDepthCnv)
                        ) ? (
                        <Box>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                              value={cnvValue}
                              onChange={(e: any, newValue) => {
                                //

                                if (e.target.innerText === 'CNV Exon') {
                                  //
                                }

                                setCnvValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              {/* <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV ALL')}
                                {...a11yProps(0)}
                              /> */}

                              {/* <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Sentieon CNV')}
                                {...a11yProps(1)}
                              /> */}

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV Exon')}
                                {...a11yProps(0)}
                              />

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV chart')}
                                {...a11yProps(1)}
                              />

                              {!analysisInfo.pipelineVersion && (
                                <Tab
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                  label={t('Gene display')}
                                  {...a11yProps(2)}
                                />
                              )}
                            </Tabs>
                          </Box>

                          {/* <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              query={chipQuery}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={chipQuery.key}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              colorToggle={colorToggle}
                            />
                          </TabPanel> */}

                          {/* <TabPanel value={cnvValue} index={1}>
                            <VariationTables
                              query={{
                                title: 'Sentieon CNV',
                                checked: true,
                                key: '9'
                              }}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={'8'}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              colorToggle={colorToggle}
                            />
                          </TabPanel> */}

                          <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              setSelectRowKey={setSelectRowKey}
                              query={{
                                title: 'CNV Exon',
                                checked: true,
                                key: '8'
                              }}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={'8'}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              indexChecked={indexChecked}
                              colorToggle={colorToggle}
                            />
                          </TabPanel>

                          <TabPanel value={cnvValue} index={1}>
                            <Tabs
                              value={cnvAllValue}
                              onChange={(e, newValue) => {
                                setCnvAllValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Exons level')}
                                {...a11yProps(0)}
                              />

                              {/* <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Chr level')}
                                {...a11yProps(1)}
                              /> */}
                            </Tabs>

                            <TabPanel value={cnvAllValue} index={0}>
                              <CnvHG19QcPlot
                                onlyChrom={false}
                                analysisInfo={analysisInfo}
                              />
                            </TabPanel>

                            {/* <TabPanel value={cnvAllValue} index={1}>
                              <CnvDellyQcPlot analysisInfo={analysisInfo} />
                            </TabPanel> */}
                          </TabPanel>

                          <TabPanel value={cnvValue} index={2}>
                            <CnvGeneDisplay
                              data={[]}
                              id={id as unknown as number}
                            />
                          </TabPanel>
                        </Box>
                      ) : sampleList?.some(
                          (sample) =>
                            sample.vcfType === 'wgs' &&
                            (sample.hasCnv || sample.cnvKitFile)
                        ) ? (
                        <Box>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                              value={cnvValue}
                              onChange={(e: any, newValue) => {
                                //

                                if (e.target.innerText === 'CNV Exon') {
                                  //
                                }

                                setCnvValue(newValue)
                              }}
                              aria-label="basic tabs example"
                              id={'header4'}
                            >
                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('CNV ALL')}
                                {...a11yProps(0)}
                              />

                              <Tab
                                sx={{
                                  textTransform: 'capitalize'
                                }}
                                label={t('Chr level')}
                                {...a11yProps(1)}
                              />

                              {!analysisInfo.pipelineVersion && (
                                <Tab
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                  label={t('Gene display')}
                                  {...a11yProps(2)}
                                />
                              )}
                            </Tabs>
                          </Box>

                          <TabPanel value={cnvValue} index={0}>
                            <VariationTables
                              setSelectRowKey={setSelectRowKey}
                              query={chipQuery}
                              config={{
                                ...filterQuery,
                                ...variantListConfig
                              }}
                              ref={tableRef}
                              key={chipQuery.key}
                              analysisInfo={analysisInfo}
                              FilterSelect={filterToggle}
                              indexChecked={indexChecked}
                              colorToggle={colorToggle}
                            />
                          </TabPanel>

                          <TabPanel value={cnvValue} index={1}>
                            <CnvDellyQcPlot analysisInfo={analysisInfo} />
                          </TabPanel>

                          <TabPanel value={cnvValue} index={2}>
                            <CnvGeneDisplay
                              data={[]}
                              id={id as unknown as number}
                            />
                          </TabPanel>
                        </Box>
                      ) : (
                        <Box>
                          <Tabs
                            value={cnvAllValue}
                            onChange={(e, newValue) => {
                              setCnvAllValue(newValue)
                            }}
                            aria-label="basic tabs example"
                            id={'header4'}
                          >
                            <Tab
                              sx={{
                                textTransform: 'capitalize'
                              }}
                              label={t('Chr level')}
                              {...a11yProps(0)}
                            />
                          </Tabs>

                          <TabPanel value={cnvAllValue} index={0}>
                            <CnvKitQcPlot analysisInfo={analysisInfo} />
                          </TabPanel>
                        </Box>
                      )}
                    </Box>
                  ) : chipQuery.title?.includes('HLA') ? (
                    <Box>
                      {sampleList?.length ? (
                        <HLAChild
                          hlaData={hlaData}
                          analysisInfo={analysisInfo}
                        />
                      ) : (
                        ''
                      )}
                    </Box>
                  ) : (
                    <VariationTables
                      setSelectRowKey={setSelectRowKey}
                      query={chipQuery}
                      config={{
                        ...filterQuery,
                        ...variantListConfig
                      }}
                      ref={tableRef}
                      key={chipQuery.key}
                      analysisInfo={analysisInfo}
                      FilterSelect={Boolean(filterToggle)}
                      indexChecked={indexChecked}
                      colorToggle={colorToggle}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={3}>
        <Report
          analysisInfo={analysisInfo}
          getReportsVariants={getReportsVariants}
        />
      </TabPanel>

      <TabPanel value={value} index={0}>
        {sampleList?.map((sample: any) => {
          return (
            <Box>
              <PatientInformation
                analysisInfo={analysisInfo}
                termList={sample.terms}
                samples={sample}
                clinicalInformation={sample.clinicalInformation}
              />
            </Box>
          )
        })}
      </TabPanel>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'click-menu'
        }}
      >
        {menuList.map((item: any, index) => {
          return (
            <MenuItem
              onClick={(event) => handleAddReport(event, index, item)}
              key={item.title}
            >
              {`${item.title}(${item.value.length})`}
            </MenuItem>
          )
        })}
      </Menu>

      <Menu
        id="basic-menu"
        anchorEl={anchorGenomeBuildEl}
        open={openGenomeBuild}
        onClose={() => {
          setAnchorGenomeBuildEl(null)
        }}
        MenuListProps={{
          'aria-labelledby': 'click-menu'
        }}
      >
        <MenuItem
          onClick={(event) => {
            editSamples.mutateAsync({
              id: analysisInfo.id,
              name: analysisInfo.name,
              projectId: analysisInfo.projectId,
              genomeBuild: 'hg19',
              gender: analysisInfo.gender
            })
          }}
          key={'hg19'}
          disabled={analysisInfo.genomeBuild === 'hg19'}
        >
          {'hg19'}
        </MenuItem>

        <MenuItem
          onClick={(event) => {
            editSamples.mutateAsync({
              id: analysisInfo.id,
              name: analysisInfo.name,
              projectId: analysisInfo.projectId,
              genomeBuild: 'hg38',
              gender: analysisInfo.gender
            })
          }}
          key={'hg38'}
          disabled={analysisInfo.genomeBuild === 'hg38'}
        >
          {'hg38'}
        </MenuItem>
      </Menu>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorCsvEl}
        open={openCsv}
        onClose={handleCsvClose}
      >
        <MenuItem
          onClick={async () => {
            messageRef?.current?.handleClick(
              t('Exporting, please wait'),
              'info'
            )

            sampleList?.map(async (items: any) => {
              if (items.sampleType === 'vcf') {
                if (items.pipelineVersion) {
                  const data = await fetchBamUrl.mutateAsync(
                    id as unknown as number
                  )
                  if (data && data.vcfUrl) {
                    const downloadLink = document.createElement('a')
                    downloadLink.href = data.vcfUrl
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                    document.body.removeChild(downloadLink)
                  }
                } else if (items.sampleLocation === 'local') {
                  handleGetSignedUrl.mutateAsync({
                    type: OssSignedUrlType.SAMPLE,
                    obj: `${items.id}/vcf_results/${items.prefix}.vcf_tsv.af.vcf.gz`,
                    prefix: '.vcf_tsv.af.vcf.gz'
                  })

                  // download2.mutateAsync({
                  //   parent: `/mnt/storage/genomics-data/samples/${items.id}/vcf_results/${items.prefix}.vcf_tsv.af.vcf.gz`,
                  //   filename: `${items.prefix}.vcf_tsv.af.vcf.gz`
                  // })
                } else {
                  const key = `uploads/${analysisInfo.vcfFile}`

                  // download.mutateAsync(`uploads/${analysisInfo.vcfFile}`)

                  const client = await handleOss()

                  if (client) {
                    const data = await client.get(key)

                    const blob = new Blob([data.content], {
                      type: 'text/plain'
                    })
                    const url = URL.createObjectURL(blob)

                    // 创建一个下载链接

                    const downloadLink = document.createElement('a')

                    downloadLink.href = url

                    downloadLink.download = `${analysisInfo.vcfFile}` as string

                    document.body.appendChild(downloadLink)

                    downloadLink.click()

                    document.body.removeChild(downloadLink)

                    //
                  }
                }
              } else if (
                items.sampleType === 'fastq' ||
                items.sampleType === 'naf'
              ) {
                if (items.pipelineVersion) {
                  const data = await fetchBamUrl.mutateAsync(
                    id as unknown as number
                  )
                  if (data && data.vcfUrl) {
                    const downloadLink = document.createElement('a')
                    downloadLink.href = data.vcfUrl
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                    document.body.removeChild(downloadLink)
                  }
                } else if (items.sampleLocation === 'local') {
                  handleGetSignedUrl.mutateAsync({
                    type: OssSignedUrlType.SAMPLE,
                    obj: `${items.id}/vcf_results/${items.prefix}.vcf_tsv.af.vcf.gz`,
                    prefix: '.vcf_tsv.af.vcf.gz'
                  })

                  // download2.mutateAsync({
                  //   parent: `/mnt/storage/genomics-data/samples/${items.id}/vcf_results/${items.prefix}.vcf_tsv.af.vcf.gz`,
                  //   filename: `${items.prefix}.vcf_tsv.af.vcf.gz`
                  // })
                } else {
                  const key = `samples/${items.id}/vcf_results/${items.prefix}.vcf_tsv.af.vcf.gz`

                  const client = await handleOss()

                  if (client) {
                    const data = await client.get(key)

                    //
                    const blob = new Blob([data.content], {
                      type: 'text/plain'
                    })
                    const url = URL.createObjectURL(blob)

                    // 创建一个下载链接

                    const downloadLink = document.createElement('a')

                    downloadLink.href = url

                    downloadLink.download =
                      `${analysisInfo.name}.vcf_tsv.af.vcf.gz` as string

                    document.body.appendChild(downloadLink)

                    downloadLink.click()

                    document.body.removeChild(downloadLink)

                    //
                  }
                }
              }
            })
          }}
          disableRipple
        >
          {`${t('download')} VCF`}
        </MenuItem>

        <MenuItem
          onClick={async () => {
            if (analysisInfo.pipelineVersion) {
              const data = await fetchBamUrl.mutateAsync(
                id as unknown as number
              )
              if (data && data.bamUrl) {
                const downloadLink = document.createElement('a')
                downloadLink.href = data.bamUrl
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
              }
            } else
              handleGetSignedUrl.mutateAsync({
                type: OssSignedUrlType.SAMPLE,
                obj: `${id}/fastq_results/${analysisInfo.prefix}.deduped.bam`,
                prefix: '.deduped.bam'
              })
          }}
          disableRipple
        >
          {`${t('export')} bam文件`}
        </MenuItem>

        {!analysisInfo.pipelineVersion &&
        analysisInfo.sampleType === 'fastq' ? (
          <MenuItem
            onClick={() => {
              handleGetSignedUrl.mutateAsync({
                type: OssSignedUrlType.SAMPLE,
                obj: `${id}/fastq_results/${analysisInfo.prefix}.final.vcf.gz`,
                prefix: '.final.vcf.gz'
              })
            }}
            disableRipple
          >
            {`${t('export')} 原始VCF`}
          </MenuItem>
        ) : (
          ''
        )}

        {analysisInfo.hasRoh ? (
          <MenuItem
            onClick={async () => {
              if (analysisInfo.pipelineVersion) {
                const data = await getGlsRohList.mutateAsync(
                  id as unknown as number
                )

                exportVariantsList(data.regions)
              } else {
                const data = await getRohList.mutateAsync(
                  id as unknown as number
                )

                data.data.shift()

                exportVariantsList(data.data)
              }
            }}
            disableRipple
          >
            {`${t('export')} ROH`}
          </MenuItem>
        ) : (
          ''
        )}

        {analysisInfo.pipelineVersion ? (
          <MenuItem
            onClick={() => {
              handleExportSmallVariants.mutateAsync({
                id: id as unknown as number,
                source: 'samples',
                format: 'tsv',
                columns: [
                  'chrom',
                  'pos',
                  'ref',
                  'alt',
                  'gene',
                  'gls_classification',
                  'f_score'
                ],
                sort_by: [{ field: 'f_score', order: 'desc' }]
              })
            }}
            disableRipple
          >
            {`${t('export')} ${t('Variant list')} TSV`}
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => {
              if (analysisInfo.vcfType === 'wgs')
                handleGetSignedUrl.mutateAsync({
                  type: OssSignedUrlType.SAMPLE,
                  obj: `${id}/fastq_results/${id}.delly.cnv.vcf`,
                  prefix: '.delly.cnv.vcf'
                })
              else if (analysisInfo.vcfType === 'wes')
                handleGetSignedUrl.mutateAsync({
                  type: OssSignedUrlType.SAMPLE,
                  obj: `${id}/fastq_results/${id}.cnv.vcf`,
                  prefix: '.cnv.vcf'
                })
            }}
            disableRipple
          >
            {`${t('export')} CNV`}
          </MenuItem>
        )}

        <MenuItem
          onClick={async () => {
            // if (analysisInfo.vcfType === 'wgs')
            //   handleGetSignedUrl.mutateAsync({
            //     type: OssSignedUrlType.SAMPLE,
            //     obj: `${id}/fastq_results/str.tsv`,
            //     prefix: '.tsv'
            //   })
            // else if (analysisInfo.vcfType === 'wes')
            //   handleGetSignedUrl.mutateAsync({
            //     type: OssSignedUrlType.SAMPLE,
            //     obj: `${id}/fastq_results/str.tsv`,
            //     prefix: '.tsv'
            //   })

            try {
              messageRef?.current?.handleClick(
                t('Exporting, please wait'),
                'info'
              )
              let datas: any[] = []
              if (analysisInfo.pipelineVersion) {
                const total = tableRef.current.totalCount ?? 200 // 总数据量
                const pageSize = 100 // 每页最大数量
                const totalPages = Math.floor(total / pageSize) // 计算总页数
                // 创建所有页的请求数组
                const requests = []
                for (let pageNum = 0; pageNum <= totalPages; pageNum++) {
                  // 最后一页时，计算实际需要的pageSize
                  const currentPageSize =
                    pageNum === totalPages
                      ? total - pageNum * pageSize
                      : pageSize
                  requests.push(
                    getGlsStrDatas.mutateAsync({
                      parquetType: 'str',
                      variants: {
                        id,
                        source: 'samples',
                        offset: pageNum * pageSize,
                        limit: currentPageSize,
                        filters: [],
                        sort_by: []
                      }
                    })
                  )
                }
                const GlsFastTrackData = await Promise.all(requests)
                datas = GlsFastTrackData.map((i) => i.items).flat() ?? []
              } else {
                const StrData = await getStrDatas.mutateAsync({
                  pageNum: 1,
                  pageSize: 1000,
                  filter: {},
                  sort: { f_score: -1 }
                })

                //
                datas = (StrData?.data?.list ?? []) as any[]
              }

              const geneNames = datas
                .map((item) => {
                  if (item.gene && item.gene.split) return item.gene.split(';')
                  else return item.gene
                })
                .filter((item) => item)
                .flat()

              if (geneNames.length) {
                const OMIMs: VariantDetailOmimData[] =
                  await getOMIM.mutateAsync({
                    geneNames
                  })
                const data = await Promise.all(
                  OMIMs.map(async (items) => {
                    items.omimData = await Promise.all(
                      items.omimData.map(async (item: any) => {
                        return {
                          ...item,
                          isCheck: true
                        }
                      })
                    )

                    return items
                  })
                )

                datas = datas.map((items) => {
                  const tempOMIM = data.find(
                    (item) => item.geneName === items.gene
                  )

                  if (tempOMIM) items.OMIM = tempOMIM

                  return items
                })
              }

              const dataSource = datas ?? []
              const column = [
                {
                  title: 'chrom',
                  key: 'chrom'
                },
                {
                  title: 'start',
                  key: 'start'
                },
                {
                  title: 'end',
                  key: 'end'
                },
                {
                  title: 'RU',
                  key: 'RU'
                },
                {
                  title: 'gene',
                  key: 'gene'
                },
                {
                  title: 'GangSTR_repcn',
                  key: 'GangSTR_repcn'
                },
                {
                  title: 'GangSTR_repci',
                  key: 'GangSTR_repci'
                },
                {
                  title: 'GangSTR_dp',
                  key: 'GangSTR_dp'
                },
                {
                  title: 'GangSTR_q',
                  key: 'GangSTR_q'
                },
                {
                  title: 'EH_repcn',
                  key: 'EH_repcn'
                },
                {
                  title: 'EH_repci',
                  key: 'EH_repci'
                },
                {
                  title: 'EH_ref',
                  key: 'EH_ref'
                },
                {
                  title: 'STR_Result',
                  key: 'STR_Result'
                },
                {
                  title: '参考范围',
                  key: 'rang'
                },
                {
                  title: 'OMIM',
                  key: 'OMIMValue_OMIM'
                }
              ]
              const data = [] as any[]
              const groupSize = 2

              for (let i = 0; i < dataSource.length; i += groupSize) {
                const group = dataSource.slice(i, i + groupSize)

                const groupResults = group.map((items) => {
                  const rang = strRang.find((item) => item.gene == items.gene)

                  items['rang'] = `${rang ? `n < ${rang.max}` : '-'}`
                  items.RU = items.RU ?? items.repeat_unit
                  items.EH_repci = items.EH_repci ?? items.eh_repci
                  items.EH_ref = items.EH_ref ?? items.eh_ref
                  items.GangSTR_repci =
                    items.GangSTR_repci ?? items.gangstr_repci
                  items.GangSTR_dp = items.GangSTR_dp ?? items.gangstr_dp
                  items.GangSTR_q = items.GangSTR_q ?? items.gangstr_q
                  items['chrom'] =
                    items.chrom && items.chrom.includes('chr')
                      ? `${items.chrom}`
                      : `chr${items.chrom}`

                  items['GangSTR_repcn'] = items.GangSTR_repcn
                    ? `\t${items.GangSTR_repcn}"`
                    : items.gangstr_repcn
                    ? `\t${items.gangstr_repcn.join('/')}"`
                    : ''
                  items['EH_repcn'] = items.EH_repcn
                    ? `\t${items.EH_repcn}"`
                    : items.eh_repcn
                    ? `\t${items.eh_repcn.join('/')}"`
                    : ''

                  const GangSTR_repcn = items.GangSTR_repcn
                  const EH_repcn = items.EH_repcn
                  const GangSTR_first = GangSTR_repcn.includes('/')
                    ? GangSTR_repcn.split('/')[0]
                    : 0
                  const GangSTR_second = GangSTR_repcn.includes('/')
                    ? GangSTR_repcn.split('/')[1]
                    : 0
                  const EH_first = EH_repcn.includes('/')
                    ? EH_repcn.split('/')[0]
                    : 0
                  const EH_second = EH_repcn.includes('/')
                    ? EH_repcn.split('/')[1]
                    : 0
                  const temp = strRang.find((item) => item.gene == items.gene)
                  let flag = false

                  if (
                    temp &&
                    (GangSTR_first > temp.max ||
                      GangSTR_second > temp.max ||
                      EH_first > temp.max ||
                      EH_second > temp.max)
                  ) {
                    flag = true
                  }

                  items.STR_Result = `${
                    temp ? (flag ? t('risky') : t('risk-free')) : '-'
                  }`

                  items['OMIMValue_OMIM'] = items.OMIM?.omimData
                    .map((item: any) => {
                      const inheritances: string[] = []

                      if (
                        item &&
                        item.clinicalSynopsis &&
                        item.clinicalSynopsis.INHERITANCE &&
                        Array.isArray(item.clinicalSynopsis.INHERITANCE)
                      ) {
                        item.clinicalSynopsis.INHERITANCE.forEach(
                          (str: string) => inheritances.push(str.toLowerCase())
                        )
                      }
                      const inheritance = formatVariantInheritance(
                        Array.from([...new Set(inheritances)]).join(',')
                      )

                      return {
                        ...item,
                        inheritance
                      }
                    })
                    .map(
                      (items: any) =>
                        `(${items.inheritance ? items.inheritance : '.'})-${
                          items.phenoName
                        }-${items.pheno_name_cn}`
                    )
                    .join(';')

                  return items
                })

                data.push(...groupResults)
              }

              const arr = data.map((item) => {
                const obj: NObject = {}

                column.map((i) => {
                  obj[i.title] = item[i.key]
                })

                return obj
              })

              messageRef?.current?.handleClick(t('Export success'), 'success')

              // 导出XLSX
              const worksheet = XLSX.utils.json_to_sheet(arr)
              const workbook = XLSX.utils.book_new()

              XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

              XLSX.writeFile(
                workbook,
                `${analysisInfo.name}-${formatDate(new Date())}.xlsx`
              )

              messageRef?.current?.handleClick(t('Export success'), 'success')

              //
            } catch (error) {
              //

              messageRef?.current?.handleClick(t('Export failure'), 'error')
            }
          }}
          disableRipple
        >
          {`${t('export')} STR`}
        </MenuItem>

        {!analysisInfo.pipelineVersion && analysisInfo.vcfType === 'wgs' ? (
          <MenuItem
            onClick={() => {
              handleGetSignedUrl.mutateAsync({
                type: OssSignedUrlType.SAMPLE,
                obj: `${id}/fastq_results/${analysisInfo.prefix}.sentieon.sv.vcf`,
                prefix: '.sentieon.sv.vcf'
              })
            }}
            disableRipple
          >
            {`${t('export')} SV`}
          </MenuItem>
        ) : (
          ''
        )}

        {/* <MenuItem
          onClick={() => {
            if (selectRowKey && selectRowKey.length) handleExportCsv('诺和')
            else {
              messageRef?.current?.handleClick(
                t('Please check the list of variants you want to export first'),
                'warning'
              )

              handleCsvClose()
            }
          }}
          disableRipple
        >
          {`${t('export')} CSV（诺和）`}
        </MenuItem>

        <MenuItem
          onClick={() => {
            if (selectRowKey && selectRowKey.length) handleExportCsv('安诺')
            else {
              messageRef?.current?.handleClick(
                t('Please check the list of variants you want to export first'),
                'warning'
              )

              handleCsvClose()
            }
          }}
          disableRipple
        >
          {`${t('export')} CSV（安诺）`}
        </MenuItem> */}

        {(chipQuery.title === '快捷窗口' || chipQuery.title === 'Fast track') &&
        process.env.SYSTEM === 'chongqing' ? (
          <MenuItem
            onClick={() => {
              messageRef?.current?.handleClick(t('导出中，请稍后'), 'info')

              handleExportCsv('重庆', tableRef.current.data.slice(0, 10) ?? [])
            }}
            disableRipple
          >
            {`${t('export')} CSV（重庆）`}
          </MenuItem>
        ) : (
          ''
        )}

        <MenuItem
          onClick={() => {
            if (selectRowKey && selectRowKey.length) setExportOpen(true)
            else {
              messageRef?.current?.handleClick(
                t('Please check the list of variants you want to export first'),
                'warning'
              )

              handleCsvClose()
            }
          }}
          disableRipple
        >
          {`${t('export')} ${t('Variant list')}`}
        </MenuItem>

        {chipQuery.key === '0' ? (
          <MenuItem
            onClick={async () => {
              try {
                messageRef?.current?.handleClick(
                  t('Exporting, please wait'),
                  'info'
                )

                let datas = [] as any[]
                if (analysisInfo.pipelineVersion) {
                  const total = tableRef.current.totalCount ?? 0 // 总数据量
                  const pageSize = 100 // 每页最大数量
                  const totalPages = Math.floor(total / pageSize) // 计算总页数
                  // 创建所有页的请求数组
                  const requests = []
                  for (let pageNum = 0; pageNum <= totalPages; pageNum++) {
                    // 最后一页时，计算实际需要的pageSize
                    const currentPageSize =
                      pageNum === totalPages
                        ? total - pageNum * pageSize
                        : pageSize
                    requests.push(
                      getGlsFastTrackData.mutateAsync({
                        parquetType: 'small',
                        variants: {
                          id,
                          source: 'samples',
                          offset: pageNum * pageSize,
                          limit: currentPageSize,
                          filters: [
                            { field: 'is_fast_track', op: 'eq', value: true }
                          ],
                          sort_by: []
                        }
                      })
                    )
                  }
                  const GlsFastTrackData = await Promise.all(requests)
                  datas = GlsFastTrackData.map((i) => i.items).flat() ?? []
                } else {
                  const FastTrackData = await getFastTrackData.mutateAsync({
                    pageNum: 1,
                    pageSize: 1000,
                    filter: {},
                    sort: {}
                  })
                  datas = FastTrackData?.data?.list ?? []
                }

                const geneNames = datas
                  .map((item) => {
                    if (item.gene && item.gene.split)
                      return item.gene.split(';')
                    else return item.gene
                  })
                  .filter((item) => item)
                  .flat()

                if (geneNames.length && !analysisInfo.pipelineVersion) {
                  const OMIMs: VariantDetailOmimData[] =
                    await getOMIM.mutateAsync({
                      geneNames
                    })
                  const data = await Promise.all(
                    OMIMs.map(async (items) => {
                      items.omimData = await Promise.all(
                        items.omimData.map(async (item: any) => {
                          return {
                            ...item,
                            isCheck: true
                          }
                        })
                      )

                      return items
                    })
                  )

                  datas = datas.map((items) => {
                    const tempOMIM = data.find(
                      (item) => item.geneName === items.gene
                    )

                    if (tempOMIM) items.OMIM = tempOMIM

                    return items
                  })
                }

                const dataSource = datas ?? []
                const column = [
                  {
                    title: '基因',
                    key: 'gene',
                    value: '遗传信息的基本单位'
                  },
                  {
                    title: '转录ID',
                    key: 'transcript',
                    value: '基因转录产物的唯一标识符'
                  },
                  {
                    title: '位点',
                    key: 'chrom+pos',
                    value: '基因组上的具体位置（染色体+坐标）'
                  },
                  {
                    title: 'dbSNP',
                    key: 'rs_id',
                    value: '单核苷酸多态性数据库标识符'
                  },
                  {
                    title: '影响',
                    key: 'coding_effect',
                    value: '变异对编码区的影响类型'
                  },
                  {
                    title: '位置',
                    key: 'var_location+exon',
                    value: '变异在外显子中的具体位置'
                  },
                  {
                    title: '碱基变化',
                    key: 'nuc_change+c_nomen+p_nomen',
                    value: 'DNA/RNA/蛋白质水平的碱基变化描述'
                  },
                  {
                    title: '合子/覆盖度',
                    key: 'allele_frequency+coverage',
                    value: '变异等位基因频率及测序覆盖深度'
                  },
                  {
                    title: '质量',
                    key: 'QUAL',
                    value: '变异检测的质量评分'
                  },
                  {
                    title: 'gAD_ALL',
                    key: 'gnomAD_exome_ALL',
                    value: 'gnomAD数据库中所有人群的等位基因频率'
                  },
                  {
                    title: 'gAD_EAS',
                    key: 'gnomAD_exome_EAS',
                    value: 'gnomAD数据库中东亚人群的等位基因频率'
                  },
                  {
                    title: 'F score',
                    key: 'f_score',
                    value: '变异致病性预测的功能评分'
                  },
                  {
                    title: 'G score',
                    key: 'g_score',
                    value: '变异致病性预测的综合评分'
                  },
                  {
                    title: 'SpliceAI',
                    key: 'SpliceAI_max_score',
                    value: '预测变异对剪接影响的最大分数'
                  },
                  {
                    title: 'Revel',
                    key: 'REVEL_score',
                    value: '变异致病性的综合预测评分'
                  },
                  {
                    title: 'AlphaM',
                    key: 'AM_pathogenicity',
                    value: 'AlphaMissense预测的致病性分类'
                  },
                  {
                    title: 'Clinvar',
                    key: 'CLINVAR_clnsig_final',
                    value: 'ClinVar数据库中的临床意义分类'
                  },
                  {
                    title: '校勘',
                    key: 'curation',
                    value: '变异的人工审核和分类结果'
                  },
                  {
                    title: 'ACMG',
                    key: 'ACMG',
                    value: 'ACMG指南的致病性分类标准'
                  },
                  {
                    title: 'ACMGEvidences',
                    key: 'acmgEvidences',
                    value: '支持ACMG分类的具体证据条目'
                  },
                  {
                    title: 'OMIM',
                    key: 'OMIMValue_OMIM',
                    value: 'OMIM数据库中与基因相关的疾病条目'
                  }
                ]

                const data = [] as any[]
                const groupSize = 2

                for (let i = 0; i < dataSource.length; i += groupSize) {
                  const group = dataSource.slice(i, i + groupSize)

                  const groupResults = group.map((items) => {
                    items['chrom+pos'] = `${items.chrom}:${items.pos}`

                    items['var_location+exon'] = items.var_location
                      ? `${items.var_location}:${items.exon}`
                      : items.variant_locations
                      ? `${items.variant_locations[0]}:${items.exon}`
                      : ''

                    items['nuc_change+c_nomen+p_nomen'] = items.nuc_change
                      ? `${items.nuc_change}:${items.c_nomen}:${items.p_nomen}`
                      : items.hgvsc
                      ? `${items.ref}>${items.alt}:${items.hgvsc}:${items.hgvsp}`
                      : ''

                    items['allele_frequency+coverage'] = items.allele_frequency
                      ? `[${items.allele_frequency}]:${items.coverage}`
                      : items.allele_balance
                      ? `[${items.allele_balance}]:${items.ad}`
                      : ''

                    items['ACMG'] = items.ACMG_classification
                      ? `${items.ACMG_classification?.split(' ')
                          .map((word: string) => {
                            if (word.includes('Uncertain')) return `VU`
                            if (word.includes('null')) return ``
                            else return word[0].toUpperCase()
                          })
                          .join('')}`
                      : items.acmg_classification
                      ? `${items.acmg_classification}`
                      : ''

                    items['acmgEvidences'] = items.acmg_evidences
                      ? `${items.acmg_evidences.join('+')}`
                      : ''

                    items['SpliceAI_max_score'] = items.SpliceAI_max_score
                      ? `${items.SpliceAI_max_score}`
                      : items.spliceai_max_score
                      ? `${items.spliceai_max_score}`
                      : ''

                    items['REVEL_score'] = items.REVEL_score
                      ? `${items.REVEL_score}`
                      : items.revel
                      ? `${items.revel}`
                      : ''

                    items['AM_pathogenicity'] = items.AM_pathogenicity
                      ? `${items.AM_pathogenicity}`
                      : items.am_pathogenicity
                      ? `${items.am_pathogenicity}`
                      : ''

                    items['curation'] = items.curation
                      ? `${items.curation}`
                      : ''

                    const newOMIMData = items.OMIM?.geneDiseaseTranslated?.data
                      ? items.OMIM?.geneDiseaseTranslated?.data
                      : items.omim_curate_phenotypes
                      ? items.omim_curate_phenotypes
                      : []
                    items['OMIMValue_OMIM'] = `${unique(newOMIMData, 'disease')
                      .map((item: { genetic_mode: any; disease: any }) => {
                        return `${item.genetic_mode}--${item.disease}`
                      })
                      .filter((item) => item)
                      .join(',')}`

                    return items
                  })

                  data.push(...groupResults)
                }

                const arr = data.map((item) => {
                  const obj: NObject = {}

                  column.map((i) => {
                    obj[i.title] = item[i.key]
                  })

                  return obj
                })

                messageRef?.current?.handleClick(t('Export success'), 'success')

                // 导出XLSX
                const worksheet1 = XLSX.utils.json_to_sheet(arr)
                const worksheet2 = XLSX.utils.json_to_sheet(column)
                const workbook = XLSX.utils.book_new()

                XLSX.utils.book_append_sheet(workbook, worksheet1, 'Sheet1')
                XLSX.utils.book_append_sheet(workbook, worksheet2, 'read me')

                XLSX.writeFile(
                  workbook,
                  `${analysisInfo.name}-${formatDate(new Date())}.xlsx`
                )

                messageRef?.current?.handleClick(t('Export success'), 'success')

                //
              } catch (error) {
                //

                messageRef?.current?.handleClick(t('Export failure'), 'error')
              }
            }}
            disableRipple
          >
            {`${t('export')} ${t('Fast track')}`}
          </MenuItem>
        ) : (
          ''
        )}

        {/* <MenuItem
          onClick={() => {
            exportAll()
          }}
          disableRipple
        >
          {`${t('export all')}`}
        </MenuItem> */}
      </StyledMenu>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={dialogOpen}
      >
        <AddReport handleClose={handleClose} selectRowKey={selectRowKey} />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={variantOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <VariantLists
          analysisInfo={analysisInfo}
          handleClose={handleClose}
          selectRowKey={selectRowKey}
          setConfig={setVariantListConfig}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={true}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          },
          display: upBamOpen ? 'block' : 'none'
        }}
      >
        <UpBamFile
          analysisInfo={analysisInfo}
          handleClose={handleClose}
          refetchAnalyzeInfo={refetchAnalyzeInfo}
        />
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          handleClose()
          if (id && type)
            getReportsVariants.mutateAsync({
              objectId: id as string,
              objectType: type
            })
        }}
        aria-labelledby="customized-dialog-title"
        open={downloadReportOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: '100%'
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{`${t('Selected site')}`}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            handleClose()
            if (id && type)
              getReportsVariants.mutateAsync({
                objectId: id as string,
                objectType: type
              })
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box minHeight={400}>
            <SelectReportRow
              handleExportCsv={(data: any[]) => {
                handleExportCsv('', data)
              }}
              analysisInfo={analysisInfo}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={OMIMOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: '100%'
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          {`${t('Clinical Synopsis')}(Gene:${currentOMIM?.geneName})`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => {
            setOMIMOpen(false)
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ maxWidth: '100%', minHeight: 300 }}>
          <ClinicalSynopsisDetail
            value={
              unique(
                (currentOMIM?.clinicalSynopsis as any[]) ?? [],
                'phenoName'
              ) as Record<string, any>
            }
          />
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={exportOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        {selectRowKey.length ? (
          <ExportList
            handleClose={handleClose}
            data={selectRowKey}
            exportVariantsListXlsx={(data: any[]) => {
              handleExportCsv('', data)
            }}
            analysisInfo={analysisInfo}
            columns={tableRef.current.defaultColumns}
          />
        ) : (
          ''
        )}
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={createSampleLabelsOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{`${t('Sample')} ${t('Tag')}`}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minWidth: 500, minHeight: 200 }}>
            <Grid container spacing={2} py={2} alignItems={'center'}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    fullWidth
                    value={sampleLabelValue}
                    onChange={async (event, newValue) => {
                      //

                      if (
                        newValue.length > 3 ||
                        newValue.some((i) => i.name && i.name.length > 16) ||
                        newValue.some(
                          (i) => typeof i === 'string' && i.length > 16
                        )
                      )
                        return

                      if (Array.isArray(newValue)) {
                        if (newValue.some((i) => typeof i === 'string')) {
                          const strValue = newValue.filter(
                            (item) => typeof item === 'string'
                          )

                          setSampleLabelValue(
                            unique(
                              [
                                ...newValue.filter(
                                  (item) => typeof item !== 'string'
                                ),
                                ...strValue.map((i) => {
                                  return {
                                    name: i,
                                    labelName: i
                                  }
                                })
                              ],
                              'name'
                            )
                          )
                        } else if (newValue.some((i) => i.inputValue)) {
                          const strValue = newValue.filter(
                            (item) => item.inputValue
                          )

                          setSampleLabelValue(
                            unique(
                              [
                                ...newValue.filter((item) => !item.inputValue),
                                ...strValue.map((i) => {
                                  return {
                                    name: i.inputValue,
                                    labelName: i.inputValue
                                  }
                                })
                              ],
                              'name'
                            )
                          )
                        } else if (
                          newValue.some((i) => typeof i === 'object' && i.id)
                        ) {
                          setSampleLabelValue(unique([...newValue], 'name'))
                        } else if (
                          newValue.some((i) => typeof i === 'object')
                        ) {
                          setSampleLabelValue(unique([...newValue], 'name'))
                        } else if (!newValue.length) {
                          setSampleLabelValue([])
                        }
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params)

                      const { inputValue } = params

                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.name
                      )

                      if (inputValue !== '' && !isExisting) {
                        filtered.push({
                          inputValue,
                          name: `Add "${inputValue}"`
                        })
                      }

                      return filtered
                    }}
                    size="small"
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={sampleLabel
                      .map((item) => {
                        return {
                          ...item,
                          name: item.labelName
                        }
                      })
                      .concat(lableData)}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option
                      }

                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue
                      }

                      // Regular option
                      return option.name
                    }}
                    renderOption={(props, option) => {
                      return <li {...props}>{option.name}</li>
                    }}
                    freeSolo
                    renderInput={(params) => <TextField {...params} />}
                  />

                  <FormHelperText>
                    {t(
                      'When entering a label, press Enter to create a label. The label length cannot be greater than 16, and the label quantity cannot be greater than 3.'
                    )}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Stack spacing={4} direction="row">
            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'outlined'}
              onClick={handleClose}
            >
              {t('close')}
            </Button>

            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'contained'}
              onClick={async () => {
                await Promise.all(
                  sampleLabel.map(async (item) => {
                    if (item.id) await deleteSampleSample.mutateAsync(item.id)
                  })
                )

                const newValue = sampleLabelValue.map((item) => {
                  return {
                    labelName: item.name,
                    sampleId: id as unknown as number
                  }
                })

                await Promise.all(
                  newValue.map((item) => {
                    createSampleSample.mutateAsync(item)
                  })
                )

                setSampleLabel(newValue)

                handleClose()
              }}
            >
              {t('save')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={rohOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{t('ROH')}</span>

          {RohUpd ? (
            <span
              style={{
                color: 'red',
                fontWeight: 700,
                fontSize: '16px'
              }}
            >
              {`${t('The results showed that')} ${RohUpd} ${t(
                'was suspected to be ROH'
              )}`}
            </span>
          ) : (
            ''
          )}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setRohOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minHeight: 300, minWidth: 1100 }}>
            <Grid container spacing={2} py={2} alignItems={'center'}>
              <Grid item xs={2}>
                <Button
                  onClick={() => {
                    handleChip1Click('1')

                    if (config) {
                      const newParam = [
                        ...config,
                        {
                          key: 'ROH',
                          name: 'ROH',
                          open: false,
                          value: { is_ROH: ['active'] }
                        }
                      ]

                      newParam.map((items) => {
                        if (items.key && items.key === 'chrom') {
                          items.value = {
                            chrom: [],
                            posStart: '',
                            posEnd: ''
                          }
                        }

                        return items
                      })

                      setConfig(newParam)
                    } else {
                      const newParam = [
                        {
                          key: 'ROH',
                          name: 'ROH',
                          open: false,
                          value: { is_ROH: ['active'] }
                        }
                      ]

                      setConfig(newParam)
                    }

                    handleClose()
                  }}
                  size="small"
                  variant="contained"
                  sx={{ mb: 2 }}
                >
                  {t('Filter All')}
                </Button>
              </Grid>

              <Grid xs={2.5} item>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t('Size')}
                  </InputLabel>

                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rohFilterValue.size}
                    label={t('Size')}
                    onChange={(e) => {
                      setRohFilterValue({
                        ...rohFilterValue,
                        size: Number(e.target.value)
                      })
                    }}
                  >
                    <MenuItem value={0}>{`${t('>=')}0`}</MenuItem>

                    <MenuItem value={1}>{`${t('>=')}1MB`}</MenuItem>

                    <MenuItem value={3}>{`${t('>=')}3MB`}</MenuItem>

                    <MenuItem value={10}>{`${t('>=')}10MB`}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={2.5} item>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {t('Nb Variants')}
                  </InputLabel>

                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rohFilterValue.nbVariants}
                    label={t('Nb Variants')}
                    onChange={(e) => {
                      setRohFilterValue({
                        ...rohFilterValue,
                        nbVariants: Number(e.target.value)
                      })
                    }}
                  >
                    <MenuItem value={0}>{`${t('>=')}0`}</MenuItem>

                    <MenuItem value={25}>{`${t('>=')}25`}</MenuItem>

                    <MenuItem value={50}>{`${t('>=')}50`}</MenuItem>

                    <MenuItem value={75}>{`${t('>=')}75`}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={2.5} item>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    {`${t('Percentage Homozygosity')}(%)`}
                  </InputLabel>

                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rohFilterValue.percentageHomozygosity}
                    label={`${t('Percentage Homozygosity')}(%)`}
                    onChange={(e) => {
                      setRohFilterValue({
                        ...rohFilterValue,
                        percentageHomozygosity: Number(e.target.value)
                      })
                    }}
                  >
                    <MenuItem value={0}>{`${t('>=')}0`}</MenuItem>

                    <MenuItem value={30}>{`${t('>=')}30`}</MenuItem>

                    <MenuItem value={60}>{`${t('>=')}60`}</MenuItem>

                    <MenuItem value={90}>{`${t('>=')}90`}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={1.5} item>
                <Stack direction={'row'} justifyContent="center">
                  <Window
                    sx={{
                      color: 'rgb(255,215,0)'
                    }}
                  />

                  <Typography>UPD</Typography>
                </Stack>
              </Grid>
            </Grid>

            <Index
              rows={currentRohList}
              columns={rohColumns}
              sx={{
                '& .MuiButtonBase-root': {
                  fontSize: '14px'
                },
                '& .MuiTableCell-root': {
                  fontSize: '13px'
                },
                '& .MuiTableHead-root': {
                  position: 'sticky',
                  zIndex: 2,
                  top: 0
                }
              }}
              key={JSON.stringify(currentRohList)}
            />
          </Box>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={phenotypeOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 600
          },
          '& .MuiDialog-container': {
            justifyContent: 'end',
            alignItems: 'start'
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{t('Clinical information')}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setPhenotypeOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minHeight: 300, minWidth: 580 }}>
            <Typography
              lineHeight={'2rem'}
              pl={6}
              sx={{
                background: ' url(/images/pages/Framegene.png) no-repeat',
                backgroundPosition: 'left, center',
                bgcolor: '#EBF7FA',
                color: '#08BCD4',
                marginBottom: 4,
                width: '100%'
              }}
            >
              {`${t('Clinical information')}:`}
            </Typography>

            {analysisInfo.clinicalInformation ? (
              <Typography>{`${analysisInfo.clinicalInformation}`}</Typography>
            ) : (
              <Typography>{`${t('No Results')}`}</Typography>
            )}

            <Typography
              lineHeight={'2rem'}
              pl={6}
              sx={{
                background: ' url(/images/pages/Framegene.png) no-repeat',
                backgroundPosition: 'left, center',
                bgcolor: '#EBF7FA',
                color: '#08BCD4',
                marginBottom: 4,
                width: '100%'
              }}
            >
              {`${t('phenotype')}:`}
            </Typography>

            {analysisInfo &&
            analysisInfo?.terms &&
            analysisInfo?.terms.length ? (
              analysisInfo?.terms?.map((i: any) => {
                return <Typography>{`${i.title}`}</Typography>
              })
            ) : (
              <Typography>{`${t('No Results')}`}</Typography>
            )}
          </Box>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setCnvManualOpen(false)
        }}
        aria-labelledby="customized-dialog-title"
        open={CnvManualOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{t('CNV Merge List')}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setCnvManualOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Box sx={{ minHeight: 300 }}>
            <EditAndAddTable
              expandColumns={expandCnvManualColumns}
              rows={CnvManual.map((item, index) => ({
                ...item,
                key: `${index}`
              }))}
              columns={CnvManualColumns}
              ref={EditAndAddTableRef}
              analysisInfo={analysisInfo}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Stack spacing={4} direction="row">
            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'outlined'}
              onClick={() => setCnvManualOpen(false)}
            >
              {t('close')}
            </Button>

            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              disabled={EditAndAddTableRef.current?.dataSource.length === 0}
              variant={'contained'}
              onClick={async () => {
                const data = EditAndAddTableRef.current?.dataSource as any[]

                if (data.length) {
                  if (analysisInfo.pipelineVersion) {
                    await updataCnvRecurateJob.mutateAsync({
                      sample_id: `${id}`
                    })

                    messageRef?.current?.handleClick(
                      `${t('apply')} ${t('success')}`,
                      'success'
                    )

                    setCnvManualOpen(false)
                  } else {
                    const param: UpdateMultipleCnvManualDto = {
                      variants: data
                        .filter(
                          (items) =>
                            items.start &&
                            items.end &&
                            typeof items.start === 'string' &&
                            typeof items.end === 'string'
                        )
                        .filter((items) => !items.items || !items.items.length)
                        .map((items) => ({
                          genotype: items.genotype,
                          chrom: items.chrom,
                          start: Number(items.start),
                          end: Number(items.end),
                          type: items.type,
                          cn: Number(items.cn),
                          items: []
                        })),
                      mode: 'append'
                    }

                    await updateCnvManual.mutateAsync({
                      data: param,
                      id: id as unknown as number
                    })
                  }

                  if (analysis && analysis.list && analysis.list.length) {
                    await editSampleStatus.mutateAsync({
                      id: analysis.list[0].id,
                      name: analysis.list[0].name,
                      projectId: analysis.list[0].projectId,
                      genomeBuild: analysis.list[0].genomeBuild,
                      gender: analysis.list[0].gender,
                      status: analysis.list[0].status,
                      cnvManualStatus: AdvancedTaskStatus.QUEUEING
                    })

                    messageRef?.current?.handleClick(
                      `${t('apply')} ${t('success')}`,
                      'success'
                    )

                    setCnvManualOpen(false)
                  }
                }
              }}
            >
              {t('开始合并')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setCnvChimerismOpen(false)
        }}
        aria-labelledby="customized-dialog-title"
        open={CnvChimerismOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{t('CNV chimerism')}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setCnvChimerismOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <CnvMosaicDialogContent
            analysisInfo={analysisInfo}
            CnvMosaic={CnvMosaic}
            CnvChimerismMosaism={CnvChimerismMosaism}
            CnvChimerismMosaismPng={CnvChimerismMosaismPng}
            MosaicColumns={MosaicColumns}
            CnvChimerismMosaismColumns={CnvChimerismMosaismColumns}
          />
        </DialogContent>

        <DialogActions>
          <Stack spacing={4} direction="row">
            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'outlined'}
              onClick={() => setCnvChimerismOpen(false)}
            >
              {t('close')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setCnvManualFormOpen(false)
        }}
        aria-labelledby="customized-dialog-title"
        open={CnvManualFormOpen}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: 1200
          }
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 15
          }}
          id="customized-dialog-title"
        >
          <span>{t('Cnv Manual')}</span>
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setCnvManualFormOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          {analysisInfo.pipelineVersion ? (
            <Stack sx={{ minWidth: 400 }} direction={'column'} spacing={4}>
              <FormControl fullWidth>
                <TextField
                  value={ManualValue.start}
                  disabled
                  id="outlined-basic"
                  type={'number'}
                  label={t('start')}
                  variant="outlined"
                  size="small"
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  value={ManualValue.end}
                  disabled
                  id="outlined-basic"
                  type={'number'}
                  label={t('end')}
                  variant="outlined"
                  size="small"
                />
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {`${t('CNV类型')}`}
                </InputLabel>

                <Select
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={`${t('CNV类型')}`}
                  value={ManualValue.cnvType}
                  onChange={(e) => {
                    setManualValue({
                      ...ManualValue,
                      cnvType: e.target.value
                    })
                  }}
                >
                  <MenuItem value={'DEL'}>{t('DEL')}</MenuItem>

                  <MenuItem value={'DUP'}>{t('DUP')}</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  value={ManualValue.note}
                  onChange={(e) => {
                    setManualValue({
                      ...ManualValue,
                      note: e.target.value
                    })
                  }}
                  id="outlined-basic"
                  label={t('note')}
                  variant="outlined"
                  size="small"
                />
              </FormControl>
            </Stack>
          ) : (
            <Stack sx={{ minWidth: 400 }} direction={'column'} spacing={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {`${t('基因型')}`}
                </InputLabel>

                <Select
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={`${t('基因型')}`}
                  value={ManualValue.phenotype}
                  onChange={(e) => {
                    setManualValue({
                      ...ManualValue,
                      phenotype: e.target.value
                    })
                  }}
                >
                  <MenuItem value={'0/1'}>{t('0/1')}</MenuItem>

                  <MenuItem value={'1/1'}>{t('1/1')}</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {`${t('CNV类型')}`}
                </InputLabel>

                <Select
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={`${t('CNV类型')}`}
                  value={ManualValue.cnvType}
                  onChange={(e) => {
                    setManualValue({
                      ...ManualValue,
                      cnvType: e.target.value
                    })
                  }}
                >
                  <MenuItem value={'DEL'}>{t('DEL')}</MenuItem>

                  <MenuItem value={'DUP'}>{t('DUP')}</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  value={ManualValue.CN}
                  onChange={(e) => {
                    setManualValue({
                      ...ManualValue,
                      CN: Number(e.target.value)
                    })
                  }}
                  id="outlined-basic"
                  type={'number'}
                  label={t('Copy Number(CN)')}
                  variant="outlined"
                  size="small"
                />
              </FormControl>
            </Stack>
          )}
        </DialogContent>

        <DialogActions>
          <Stack spacing={4} direction="row">
            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'outlined'}
              onClick={() => setCnvManualFormOpen(false)}
            >
              {t('close')}
            </Button>

            <Button
              sx={{
                mt: 3,
                mb: 3
              }}
              variant={'contained'}
              onClick={async () => {
                if (selectRowKey.length) {
                  if (analysisInfo.pipelineVersion) {
                    const user = JSON.parse(
                      localStorage.getItem('user') || '{}'
                    )

                    const params = {
                      genome: analysisInfo.genomeBuild,
                      sample_id: id as unknown as number,
                      parquet_type: 'cnv_exomedepth',
                      removed: selectRowKey.map((items: any) => {
                        return {
                          chrom: `${items.chrom}` as VariantChrom,
                          start: Number(items.start),
                          end: Number(items.end),
                          sv_type: items.sv_type
                        }
                      }),
                      merge_span: {
                        chrom: ManualValue.chr,
                        start: Number(ManualValue.start),
                        end: Number(ManualValue.end),
                        sv_type: ManualValue.cnvType
                      },
                      note: ManualValue.note,
                      created_by: user.email
                    }

                    await updateGLsCnvManual.mutateAsync(params)
                  } else {
                    const param: UpdateMultipleCnvManualDto = {
                      variants: createCnvManual(),
                      mode: 'append'
                    }

                    await updateCnvManual.mutateAsync({
                      data: param,
                      id: id as unknown as number
                    })
                  }
                }

                setCnvManualFormOpen(false)
              }}
            >
              {t('save')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>

      <PositionedSnackbar ref={messageRef} />
    </Box>
  )
}
